var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatBro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-1--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360,184.62c.17-1.35.32-2.73.42-4.12.37-5.06-.47-10.48-5-13.46s-13.27-3.91-17.79-.41c-3.89,3-5.82,8.06-6,12.87a11.07,11.07,0,0,0,1.34,6.06c.87,1.84,2.72,3.93,2.17,6.14-.64,2.55-5.73,8.48-5.73,8.48L335.5,208a22,22,0,0,1,5.73-4.88,12.59,12.59,0,0,1,7.06-1.81c2.86,1.62,6.18,2.19,7.14.87.84-1.16,2.22-5.19,3.35-10.45a2.55,2.55,0,0,0,2.7-1.1C362.21,189.27,360.46,185.56,360,184.62Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-1--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.77,391.39s11.76,3,11.38,4.17-13.58,3.23-14.5,3.11-1.23-6.65-1.23-6.65Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.8269559999999999px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-1--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.43,387.57a12.57,12.57,0,0,0,2.09,2.49c.93.7,4.43,2.1,4.43,3s-7,1.4-8.4,1.17-3-3-4.43-4,2.51-4.85,2.51-4.85A40,40,0,0,0,199.43,387.57Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-1--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237,223.09c-1.65-4.23-4.23-18.81-4.23-18.81-1.89-3.29-6.59-8.23-8.7-8.93s-.47,0-2.59,1.41-7.05,9.87-10.58,21.63c-1.14,3.8-2.51,9.64-3.83,15.86a94.47,94.47,0,0,0-3.79,19.27c-.95,5.27-1.57,9.14-1.57,9.83a2.23,2.23,0,0,0,1.3,1.79c0,7.61.1,11.07.1,11.07s5.61-4.44,8.41-5.61A17,17,0,0,1,227,272.7c4.27,2.85,7.71,5.38,8.18,4.21s-.6-5.24-1.4-8.65c-.94-4-2.58-15.66-2.58-15.66,0-2.82,3-17,4.44-19.16A11.48,11.48,0,0,0,237,223.09Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-1--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229,182.69c1.42,5.08-1.59,12-4.46,13.47-.89.44,2.09,4.63,4.38,7.41l2,3.46.94,4.67,1.4-.23s-1.22-5-.49-7.19S234,201,234,201a12,12,0,0,1,5-5C239.37,191.65,228.39,180.59,229,182.69Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-6--inject-1--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.55,167.11c3.32,1.67,6.94,4.45,6.94,8.48,0,7-2.86,9.83-2.86,11.6s2.35,4.11,1.47,5-2.94.58-2.94.58a64.33,64.33,0,0,1-4.7,7.36c-1.77,2.06-5-.89-8.53-3.53s-5.3-5-5.3-10-2.47-8.68-.3-13.54A12,12,0,0,1,244.55,167.11Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-7--inject-1--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.27,185.29s-1.64-5.61-3.27-4.91-1.87,3.51-1.17,5.85,2.33,2.1,3.27,1.4",
    style: {
      fill: "#fff",
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-8--inject-1--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.35,206.18c-2.47-2.09-6.33-1.21-8,3.18-2.8,7.16-5.6,14.34-8.47,21.51-2.8,7-14,41.37-15,43.94s-3,9.11-3,9.11-4.67,3.51-4.67,4.21,1.17,3.27,2.1,3.5a6.5,6.5,0,0,0,4-1.16c.93-.71,1.4-2.11,2.57-5.61,0,0,7-18.7,11.68-24.54s8.42-21,9.35-22.68a144.17,144.17,0,0,0,8.42-15.42c1.56-3.45,3.67-7.59,3.24-11.51A7,7,0,0,0,227.35,206.18Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-9--inject-1--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.41,395.63s-12.42,1.6-12.18,2.8,13.47,5.05,14.43,5.05,2.11-6.64,2.11-6.64Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.8269559999999999px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-10--inject-1--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.56,393a12.81,12.81,0,0,1-2.15,2.56c-1,.72-4.57,2.16-4.57,3.13s7.21,1.44,8.66,1.2,3.12-3.13,4.57-4.09-2.59-5-2.59-5A40.43,40.43,0,0,1,142.56,393Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-11--inject-1--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.43,237a11,11,0,0,0-3.2-2.83,17.83,17.83,0,0,1-1.89,4.53,11.06,11.06,0,0,1-1.79,2.16c3.44,4,6.08,6.88,6.4,6.8C108.92,247.44,109.16,238.48,108.43,237Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-12--inject-1--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.4,264.89l.25,6.3s3.87,3.15,12.84,3.63a32.75,32.75,0,0,0,16.23-3.63L137,261.5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-13--inject-1--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.19,204.06s-2.66,15-4.36,19.39a11.79,11.79,0,0,0,1.45,10.66c1.46,2.18,2.18,18.9,2.18,21.81s-1.93,6.79.73,9.94,16,3.88,23.51,2.91,9.69-5.58,9.69-7.76-7-30.29-10.66-42.41-8.73-20.84-10.91-22.29-.48-2.18-2.66-1.45S110.13,200.67,108.19,204.06Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-14--inject-1--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.82,241.63,125.4,245.5s-2.43,8.73-3.88,12.85-9,22.29-9,22.29-4.36,4.85-5.33,6.3-1.21,6.3-.48,7,2.42-1.7,2.42-1.7.49,1.21,2.42.24S116,282.34,116,282.34s10.17-17.45,13.81-23,6.54-10.91,6.54-13.09A27.67,27.67,0,0,0,135.82,241.63Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-15--inject-1--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.13,204.31a10.61,10.61,0,0,0-3.64,6.78c-.48,4.36,3.39,15,3.39,19.87s1,10.91,1.94,13.33,5.33,3.88,9.94,2.67,8.48-1.94,8.48-7.27-4.85-14.54-8.24-22.54S123.7,202.13,118.13,204.31Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-16--inject-1--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.05,165.75c-3.42,1.72-7.15,4.58-7.15,8.74,0,7.27,2.95,10.14,2.95,11.95s-2.43,4.25-1.52,5.16,3,.6,3,.6a67,67,0,0,0,4.85,7.58c1.82,2.12,5.16-.91,8.8-3.64s5.45-5.15,5.45-10.3,2.55-9,.31-14A12.41,12.41,0,0,0,96.05,165.75Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-1--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M453.21,362.52a11.54,11.54,0,0,0,.34-4.11c-.34-6.17-6.17-4.8-11.65-12.34-2.67-3.66-2.84-7.38-3.63-11.66-2.86-15.49-13.86-28.65-27.86-35.51-6.69-3.27-11.24-5.74-13.67-13.27-2.07-6.4-2-13.22-3.35-19.77-2.87-14.28-8.47-29.78-19.91-39.42-6.53-5.5-14.24-9.37-21.59-13.61-10-5.78-18.14-14.12-26.46-22-24.25-23-56.39-32.88-89.42-24.89a82.12,82.12,0,0,0-13.1,4.35c-21.59,9.25-20.22,42.83-29.81,47.63-7.74,3.87-22.08-5.84-29.43-8.24-25.08-8.21-48.13,6.54-51.45,32.23-1,7.54-8.21,9.53-14.19,12.1-17.47,7.53-10,26.46-12.88,41-2.4,12.34-17.14,8.91-26.05,25s-3.77,19.88-8.56,25-18.17,5.14-21.25,11.65A45.3,45.3,0,0,0,27,362.52Z",
    style: {
      fill: "#4819F2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.21,362.52a11.54,11.54,0,0,0,.34-4.11c-.34-6.17-6.17-4.8-11.65-12.34-2.67-3.66-2.84-7.38-3.63-11.66-2.86-15.49-13.86-28.65-27.86-35.51-6.69-3.27-11.24-5.74-13.67-13.27-2.07-6.4-2-13.22-3.35-19.77-2.87-14.28-8.47-29.78-19.91-39.42-6.53-5.5-14.24-9.37-21.59-13.61-10-5.78-18.14-14.12-26.46-22-24.25-23-56.39-32.88-89.42-24.89a82.12,82.12,0,0,0-13.1,4.35c-21.59,9.25-20.22,42.83-29.81,47.63-7.74,3.87-22.08-5.84-29.43-8.24-25.08-8.21-48.13,6.54-51.45,32.23-1,7.54-8.21,9.53-14.19,12.1-17.47,7.53-10,26.46-12.88,41-2.4,12.34-17.14,8.91-26.05,25s-3.77,19.88-8.56,25-18.17,5.14-21.25,11.65A45.3,45.3,0,0,0,27,362.52Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.26,352.24S214,319,205.44,309.06,180.08,295,180.08,291.92c0-5.15,21.24,8.23,17.13,4.46s-35.64-24-27.76-23.3,23,13,28.1,15.42-5.14-15.42-13-22.28-13.71-14.73-7.54-12.68,17.82,12,24.68,22.28,11.65,21.59,10.62,14.05-10.28-26.05-6.85-24,12,19.53,13.36,28.44,1.71,8.57,2.06,12.68,1.37-21.59,4.45-15.42,3.09,13.37,3.09,15.77,5.14-8.57,5.14-3.09-1,12.34-1,13.37,11-24,12.34-21.94-1,8.91-1,8.91,25-29.47,24-23.64-7.54,14.73-6.51,16.1,34.27-24.33,30.5-17.47-12.34,11.65-9.94,12.68,30.84-4.12,27.41-.35-23,1.72-24.33,5.49,30.63,9,30.91,13.91-29.54-6-33.65-6.37,16.45,8.91,15.42,13.7-23.3-8.91-24.67-9.25,5.14,5.48,2.4,7.2-9.6-2.06-16.45-1.72-2.06,3.77-2.4,6.17-8.91-1.37-13.37-.34,7.2,4.46,3.43,6.17-12.34,5.82-12.68,7.54,21.93-4.46,19.19-1.37-8.91,6.17-8.22,8.22,9.59-6.51,9.25-1-.34,7.2,1,5.14,5.14-20.56,6.85-16.1.69,15.08.69,15.08,7.19-8.57,6.16-4.46a23.48,23.48,0,0,1-4.11,7.88s14.4-3.77,9.6-1-18.51,7.88-18.51,7.88Z",
    style: {
      fill: "#4819F2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.45,326.66a2.79,2.79,0,0,0,1.27-2,1.33,1.33,0,0,0-1.42-1.39c-1.12.09-2.13,1.86-2.35,2.84,0,.09-.17,1.45-.15,1.45A9.69,9.69,0,0,0,326.45,326.66Z",
    style: {
      fill: "#4819F2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.74,348a1.09,1.09,0,0,0-1.39-.84c-.87.3-1.32,1.89-1.31,2.71,0,.05.08.67.12,1-.09-.25-.19-.49-.28-.75s-.28-.76-.42-1.14c-.06-.2-.12-.4-.19-.6s-.11-.41-.16-.62-.14-.62-.21-.94a6.91,6.91,0,0,0,2-.88,2.27,2.27,0,0,0,.88-1.7,1.08,1.08,0,0,0-1.24-1c-.9.16-1.6,1.66-1.71,2.48,0,0,0,.2,0,.4l-.15-.94c-.12-.9-.22-1.82-.32-2.74,0-.19-.05-.38-.07-.57a7.17,7.17,0,0,0,2-.91,2.27,2.27,0,0,0,.89-1.69,1.08,1.08,0,0,0-1.24-1c-.91.15-1.6,1.66-1.71,2.47,0,0,0,.24,0,.47-.06-.5-.13-1-.22-1.49a18.21,18.21,0,0,0-.58-2.5,7.53,7.53,0,0,0,2.07-.92,2.27,2.27,0,0,0,.88-1.7,1.08,1.08,0,0,0-1.24-1c-.91.16-1.6,1.66-1.71,2.48,0,.05,0,.81,0,1.07v0a13.53,13.53,0,0,0-1-2.31,17.12,17.12,0,0,0-1.18-1.92c-.39-.58-.79-1.08-1.14-1.52-.19-.24-.38-.45-.55-.65h0s-.31-1.07-.33-1.13c-.33-.75-1.41-2-2.32-1.92a1.08,1.08,0,0,0-.92,1.33,2.3,2.3,0,0,0,1.31,1.39,7.41,7.41,0,0,0,2.19.33c.17.21.36.43.55.69.35.44.73,1,1.11,1.53l.3.49-.58-.59c-.64-.51-2.17-1.14-2.94-.64a1.09,1.09,0,0,0-.2,1.61,2.27,2.27,0,0,0,1.8.63,7.18,7.18,0,0,0,2.1-.72,11.47,11.47,0,0,1,.65,1.15,13.28,13.28,0,0,1,.94,2.31s0,.09,0,.14c-.1-.14-.66-.86-.71-.91-.57-.58-2-1.37-2.85-.95a1.09,1.09,0,0,0-.38,1.57,2.24,2.24,0,0,0,1.73.82,7.62,7.62,0,0,0,2.22-.5,20.48,20.48,0,0,1,.51,2.43c.09.61.15,1.23.21,1.85-.12-.18-.65-.85-.69-.89-.58-.59-2-1.38-2.86-1a1.08,1.08,0,0,0-.37,1.57,2.26,2.26,0,0,0,1.72.83,7.8,7.8,0,0,0,2.21-.5c0,.28.05.56.08.84.08.93.16,1.85.26,2.76,0,.32.09.63.13.94-.19-.26-.56-.72-.59-.76-.58-.58-2-1.37-2.86-1a1.09,1.09,0,0,0-.38,1.57,2.28,2.28,0,0,0,1.73.83,7,7,0,0,0,2.13-.47c.08.51.18,1,.29,1.52.05.21.09.44.16.64s.12.41.17.61c.14.41.26.79.4,1.17.07.19.14.37.2.56-.16-.29-.42-.75-.45-.79-.48-.66-1.8-1.66-2.67-1.38a1.09,1.09,0,0,0-.61,1.5,2.27,2.27,0,0,0,1.58,1.08,7.72,7.72,0,0,0,2.24-.16c.17.45.34.9.5,1.3.52,1.3,1,2.37,1.35,3.1s.57,1.16.57,1.16h0a.32.32,0,1,0,.57-.31s-.22-.4-.58-1.13-.86-1.76-1.4-3q-.24-.56-.48-1.17a7.15,7.15,0,0,0,1.89-1.22A2.29,2.29,0,0,0,316.74,348Z",
    style: {
      fill: "#4819F2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.56,333.42a7.9,7.9,0,0,0,1.77-1.45,2.29,2.29,0,0,0,.41-1.87,1.09,1.09,0,0,0-1.48-.67c-.83.4-1.1,2-1,2.84C309.28,332.34,309.55,333.43,309.56,333.42Z",
    style: {
      fill: "#4819F2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.48,337.18c-.8-.45-2.29.27-2.9.83l-.7.81v0a14.85,14.85,0,0,0,.7-2.42,19.53,19.53,0,0,0,.3-2.24c.06-.69.08-1.33.09-1.89,0-.31,0-.59,0-.85h0s.44-1,.46-1.09c.23-.79.2-2.44-.56-2.95a1.09,1.09,0,0,0-1.56.44,2.29,2.29,0,0,0,.13,1.91,6.94,6.94,0,0,0,1.48,1.64c0,.27,0,.56,0,.88,0,.57-.05,1.21-.13,1.9,0,.18-.05.38-.07.57,0-.33-.07-.79-.08-.83-.16-.8-.95-2.26-1.86-2.36a1.08,1.08,0,0,0-1.18,1.11,2.31,2.31,0,0,0,1,1.63,7.4,7.4,0,0,0,2.09.78c-.07.42-.14.86-.24,1.3a14.12,14.12,0,0,1-.74,2.38l-.06.13c0-.16,0-1.08,0-1.14-.07-.82-.7-2.35-1.59-2.56a1.09,1.09,0,0,0-1.29,1,2.25,2.25,0,0,0,.8,1.73,7.64,7.64,0,0,0,2,1,19.35,19.35,0,0,1-1.16,2.2c-.31.53-.65,1.05-1,1.56,0-.21,0-1.06,0-1.13-.08-.81-.7-2.35-1.6-2.55a1.1,1.1,0,0,0-1.29,1,2.28,2.28,0,0,0,.81,1.73,7.37,7.37,0,0,0,2,1l-.48.7c-.52.77-1,1.53-1.55,2.3-.17.27-.33.54-.49.81,0-.33,0-.92,0-1-.07-.82-.7-2.35-1.59-2.55a1.08,1.08,0,0,0-1.29,1,2.25,2.25,0,0,0,.8,1.73,7.17,7.17,0,0,0,1.95,1c-.27.45-.52.91-.75,1.36-.09.2-.2.4-.28.6l-.25.58c-.16.4-.31.78-.44,1.16-.07.19-.14.37-.2.56l.16-.9c.05-.82-.34-2.43-1.19-2.76a1.09,1.09,0,0,0-1.43.76,2.3,2.3,0,0,0,.54,1.84,7.52,7.52,0,0,0,1.83,1.31c-.16.45-.31.9-.44,1.32-.43,1.33-.73,2.46-.93,3.25s-.3,1.25-.3,1.25h0a.32.32,0,0,0,.25.38.32.32,0,0,0,.38-.26s.08-.45.27-1.23.45-1.91.85-3.24c.11-.38.23-.79.37-1.2a7.64,7.64,0,0,0,2.23.26,2.25,2.25,0,0,0,1.63-1,1.1,1.1,0,0,0-.54-1.53c-.86-.32-2.22.62-2.74,1.26l-.53.84c.09-.25.17-.5.25-.76l.41-1.14.24-.59c.08-.2.17-.38.26-.58l.44-.85a6.86,6.86,0,0,0,2.07.55,2.28,2.28,0,0,0,1.76-.74,1.09,1.09,0,0,0-.31-1.59c-.8-.45-2.29.27-2.89.82,0,0-.14.15-.27.31.15-.28.31-.55.48-.83.47-.77,1-1.54,1.49-2.32l.32-.49a7.1,7.1,0,0,0,2.12.58,2.29,2.29,0,0,0,1.76-.75,1.08,1.08,0,0,0-.31-1.58c-.8-.46-2.29.26-2.89.82l-.31.35c.27-.42.53-.85.78-1.28a19.64,19.64,0,0,0,1.14-2.3,7.83,7.83,0,0,0,2.18.6,2.27,2.27,0,0,0,1.76-.75A1.09,1.09,0,0,0,353.48,337.18Z",
    style: {
      fill: "#4819F2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.89,332.31c-.89-.23-2.14.86-2.58,1.55,0,.06-.51,1.07-.5,1.07a7.83,7.83,0,0,0,2.29,0,2.27,2.27,0,0,0,1.5-1.18A1.08,1.08,0,0,0,353.89,332.31Z",
    style: {
      fill: "#4819F2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.45,326.66a9.69,9.69,0,0,0,2.65.92s-.13-1.36-.15-1.45c-.22-1-1.23-2.75-2.36-2.84a1.32,1.32,0,0,0-1.41,1.39A2.79,2.79,0,0,0,330.45,326.66Z",
    style: {
      fill: "#4819F2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.51,345.5c-1.13,0-2.22,1.76-2.49,2.73,0,0-.13.69-.18,1.1,0-.24,0-.48,0-.73,0-.5,0-1,0-1.52l-.06-.78c0-.26-.06-.53-.09-.8-.08-.62-.19-1.25-.32-1.88a9.06,9.06,0,0,0,2.66-.36,2.8,2.8,0,0,0,1.64-1.69,1.33,1.33,0,0,0-1.11-1.65c-1.12-.13-2.46,1.4-2.88,2.32,0,.06-.25.75-.36,1.13-.08-.38-.16-.76-.25-1.13-.27-1.1-.57-2.2-.87-3.3l-.27-1a9.37,9.37,0,0,0,2.76-.36,2.81,2.81,0,0,0,1.63-1.69,1.33,1.33,0,0,0-1.1-1.65c-1.12-.13-2.46,1.4-2.88,2.32,0,.07-.35,1.06-.42,1.32q-.3-1.11-.54-2.22a24.6,24.6,0,0,1-.45-3,9.27,9.27,0,0,0,2.77-.37,2.78,2.78,0,0,0,1.64-1.68,1.33,1.33,0,0,0-1.11-1.65c-1.12-.13-2.46,1.4-2.87,2.31,0,.08-.38,1.15-.43,1.35a1.1,1.1,0,0,1,0-.18,18.1,18.1,0,0,1,.1-3.06c.07-.56.16-1.09.26-1.6a9.15,9.15,0,0,0,2.73-.07,2.82,2.82,0,0,0,1.81-1.49,1.34,1.34,0,0,0-.92-1.77c-1.1-.25-2.6,1.12-3.12,2l-.42.93c.05-.23.1-.47.15-.69.19-.83.41-1.58.62-2.25.11-.37.23-.71.34-1a8.91,8.91,0,0,0,2.38-1.32,2.8,2.8,0,0,0,.92-2.16,1.34,1.34,0,0,0-1.63-1.14c-1.09.29-1.79,2.2-1.85,3.2,0,.09.08,1.46.1,1.45h0c-.11.3-.23.62-.35,1-.22.66-.46,1.41-.67,2.24a23.54,23.54,0,0,0-.55,2.71,17.26,17.26,0,0,0-.17,3.09v0c-.11-.31-.45-1.17-.48-1.24-.48-.88-1.92-2.32-3-2.12a.79.79,0,0,1-1.3,0c-1.11-.2-2.55,1.24-3,2.12,0,.07-.37.93-.48,1.24v0a17.26,17.26,0,0,0-.17-3.09,23.54,23.54,0,0,0-.55-2.71c-.21-.83-.45-1.58-.67-2.24-.12-.36-.24-.68-.35-1h0s.1-1.36.09-1.45c-.05-1-.75-2.91-1.85-3.2a1.33,1.33,0,0,0-1.62,1.14,2.77,2.77,0,0,0,.92,2.16,8.77,8.77,0,0,0,2.38,1.32c.11.31.22.65.34,1,.21.67.43,1.42.62,2.25.05.22.1.46.15.69-.17-.37-.4-.88-.43-.93-.51-.87-2-2.24-3.11-2a1.34,1.34,0,0,0-.92,1.77,2.8,2.8,0,0,0,1.81,1.49,9.15,9.15,0,0,0,2.73.07c.1.51.19,1,.25,1.6a17.09,17.09,0,0,1,.11,3.06,1.1,1.1,0,0,0,0,.18c0-.2-.4-1.27-.43-1.35-.41-.91-1.76-2.44-2.88-2.31a1.33,1.33,0,0,0-1.1,1.65,2.79,2.79,0,0,0,1.63,1.68,9.34,9.34,0,0,0,2.77.37,22.76,22.76,0,0,1-.44,3c-.16.74-.35,1.48-.54,2.22-.07-.26-.39-1.25-.42-1.32-.42-.92-1.76-2.45-2.88-2.32a1.34,1.34,0,0,0-1.11,1.65,2.82,2.82,0,0,0,1.64,1.69,9.31,9.31,0,0,0,2.75.36c-.09.34-.17.68-.26,1-.3,1.1-.61,2.2-.87,3.3-.09.37-.17.75-.25,1.13-.12-.38-.34-1.07-.37-1.13-.41-.92-1.76-2.45-2.88-2.32a1.33,1.33,0,0,0-1.1,1.65,2.81,2.81,0,0,0,1.63,1.69,9.1,9.1,0,0,0,2.66.36c-.12.63-.23,1.26-.31,1.88,0,.27-.08.54-.09.8l-.06.78c0,.53,0,1,0,1.52,0,.25,0,.49,0,.73-.06-.41-.16-1.05-.18-1.1-.27-1-1.37-2.69-2.49-2.73A1.35,1.35,0,0,0,317,347a2.81,2.81,0,0,0,1.37,1.92,9.2,9.2,0,0,0,2.65.77c0,.6,0,1.18,0,1.72.05,1.72.15,3.15.23,4.15s.16,1.57.16,1.57h0a.4.4,0,0,0,.79-.12s-.09-.55-.19-1.54-.24-2.39-.32-4.09c0-.49,0-1-.06-1.55a9,9,0,0,0,2.7-.6,2.8,2.8,0,0,0,1.49-1.82,1.35,1.35,0,0,0-1.25-1.55c-1.12,0-2.33,1.61-2.67,2.56,0,.06-.19.81-.27,1.19,0-.32,0-.64,0-1s0-1,0-1.49l0-.78c0-.26,0-.51.07-.77s.11-.78.17-1.17a8.69,8.69,0,0,0,2.62-.2,2.77,2.77,0,0,0,1.74-1.57,1.34,1.34,0,0,0-1-1.72c-1.11-.2-2.55,1.24-3,2.12,0,0-.1.23-.19.47.07-.38.14-.76.23-1.15.24-1.09.52-2.19.79-3.3.06-.23.11-.46.17-.69a9,9,0,0,0,2.69-.19,2.8,2.8,0,0,0,1.74-1.57,1.33,1.33,0,0,0-1-1.72c-1.11-.2-2.55,1.23-3,2.12l-.21.53c.14-.6.27-1.2.38-1.8a23.07,23.07,0,0,0,.39-3.13,9.32,9.32,0,0,0,2.78-.19,3.46,3.46,0,0,0,1.4-.95,3.46,3.46,0,0,0,1.4.95,9.27,9.27,0,0,0,2.77.19,24.83,24.83,0,0,0,.4,3.13c.11.6.24,1.2.38,1.8-.1-.26-.2-.5-.22-.53-.47-.89-1.91-2.32-3-2.12a1.34,1.34,0,0,0-1,1.72,2.79,2.79,0,0,0,1.75,1.57,9,9,0,0,0,2.69.19c.06.23.11.46.17.69.27,1.11.55,2.21.79,3.3.09.39.16.77.23,1.15l-.19-.47c-.48-.88-1.92-2.32-3-2.12a1.33,1.33,0,0,0-1,1.72,2.77,2.77,0,0,0,1.74,1.57,8.65,8.65,0,0,0,2.62.2c.06.39.12.78.16,1.17a6.68,6.68,0,0,1,.07.77c0,.27,0,.53,0,.78,0,.5,0,1,0,1.49s0,.66,0,1c-.08-.38-.26-1.13-.28-1.19-.33-.95-1.54-2.59-2.66-2.56a1.34,1.34,0,0,0-1.25,1.55,2.77,2.77,0,0,0,1.49,1.82,9,9,0,0,0,2.69.6c0,.54,0,1.06-.05,1.55-.08,1.7-.21,3.11-.32,4.09s-.19,1.54-.19,1.54a.4.4,0,0,0,.33.45.38.38,0,0,0,.45-.33h0s.07-.58.15-1.57.19-2.43.24-4.15c0-.54,0-1.12,0-1.72a9.2,9.2,0,0,0,2.65-.77,2.79,2.79,0,0,0,1.36-1.92A1.33,1.33,0,0,0,338.51,345.5Z",
    style: {
      fill: "#4819F2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.92,326.66a2.79,2.79,0,0,0,1.27-2,1.33,1.33,0,0,0-1.42-1.39c-1.12.09-2.13,1.86-2.35,2.84,0,.09-.17,1.45-.15,1.45A9.69,9.69,0,0,0,394.92,326.66Z",
    style: {
      fill: "#4819F2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.21,348a1.09,1.09,0,0,0-1.39-.84c-.87.3-1.33,1.89-1.31,2.71,0,.05.08.67.12,1-.09-.25-.19-.49-.28-.75s-.28-.76-.42-1.14l-.19-.6c-.07-.21-.11-.41-.16-.62s-.14-.62-.21-.94a7,7,0,0,0,1.95-.88,2.27,2.27,0,0,0,.88-1.7,1.08,1.08,0,0,0-1.24-1c-.91.16-1.6,1.66-1.71,2.48,0,0,0,.2,0,.4l-.15-.94c-.12-.9-.22-1.82-.32-2.74,0-.19-.05-.38-.07-.57a7.17,7.17,0,0,0,2-.91,2.27,2.27,0,0,0,.89-1.69,1.08,1.08,0,0,0-1.24-1c-.91.15-1.6,1.66-1.71,2.47a3.59,3.59,0,0,0,0,.47c-.06-.5-.13-1-.22-1.49a18.21,18.21,0,0,0-.58-2.5,7.66,7.66,0,0,0,2.07-.92,2.27,2.27,0,0,0,.88-1.7,1.08,1.08,0,0,0-1.24-1c-.91.16-1.6,1.66-1.71,2.48,0,.05,0,.81,0,1.07v0a13.53,13.53,0,0,0-1-2.31,17.12,17.12,0,0,0-1.18-1.92c-.39-.58-.79-1.08-1.14-1.52-.19-.24-.38-.45-.55-.65h0s-.31-1.07-.34-1.13c-.32-.75-1.4-2-2.31-1.92a1.08,1.08,0,0,0-.92,1.33,2.3,2.3,0,0,0,1.31,1.39,7.41,7.41,0,0,0,2.19.33l.55.69c.34.44.73,1,1.11,1.53l.3.49-.58-.59c-.64-.51-2.17-1.14-2.94-.64a1.09,1.09,0,0,0-.2,1.61,2.27,2.27,0,0,0,1.8.63,7.18,7.18,0,0,0,2.1-.72c.23.36.44.74.65,1.15a14.11,14.11,0,0,1,.94,2.31s0,.09,0,.14c-.1-.14-.66-.86-.71-.91-.57-.58-2-1.37-2.85-.95a1.09,1.09,0,0,0-.38,1.57,2.24,2.24,0,0,0,1.73.82,7.62,7.62,0,0,0,2.22-.5,18.66,18.66,0,0,1,.5,2.43c.09.61.16,1.23.22,1.85-.12-.18-.65-.85-.69-.89-.58-.59-2-1.38-2.86-1a1.08,1.08,0,0,0-.37,1.57,2.25,2.25,0,0,0,1.72.83,7.8,7.8,0,0,0,2.21-.5c0,.28.05.56.08.84.08.93.16,1.85.26,2.76,0,.32.09.63.13.94-.19-.26-.56-.72-.6-.76-.57-.58-2-1.37-2.85-1a1.09,1.09,0,0,0-.38,1.57,2.28,2.28,0,0,0,1.73.83,7,7,0,0,0,2.13-.47c.08.51.18,1,.29,1.52.05.21.09.44.16.64s.12.41.17.61c.14.41.26.79.4,1.17.07.19.14.37.2.56-.16-.29-.42-.75-.45-.79-.48-.66-1.8-1.66-2.67-1.38a1.09,1.09,0,0,0-.61,1.5,2.27,2.27,0,0,0,1.58,1.08,7.72,7.72,0,0,0,2.24-.16c.17.45.34.9.5,1.3.52,1.3,1,2.37,1.35,3.1s.57,1.16.57,1.16h0a.32.32,0,1,0,.57-.31s-.22-.4-.58-1.13-.86-1.76-1.4-3q-.24-.56-.48-1.17a7.15,7.15,0,0,0,1.89-1.22A2.29,2.29,0,0,0,385.21,348Z",
    style: {
      fill: "#4819F2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378,333.42A7.9,7.9,0,0,0,379.8,332a2.29,2.29,0,0,0,.41-1.87,1.09,1.09,0,0,0-1.48-.67c-.83.4-1.1,2-1,2.84C377.75,332.34,378,333.43,378,333.42Z",
    style: {
      fill: "#4819F2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422,337.18c-.8-.45-2.29.27-2.9.83l-.7.81v0a13.86,13.86,0,0,0,.69-2.42,17.64,17.64,0,0,0,.31-2.24c.06-.69.08-1.33.09-1.89,0-.31,0-.59,0-.85h0s.44-1,.46-1.09c.23-.79.2-2.44-.57-2.95a1.08,1.08,0,0,0-1.55.44,2.29,2.29,0,0,0,.13,1.91,6.94,6.94,0,0,0,1.48,1.64c0,.27,0,.56,0,.88,0,.57-.05,1.21-.13,1.9,0,.18-.05.38-.07.57,0-.33-.07-.79-.08-.83-.16-.8-.95-2.26-1.86-2.36a1.08,1.08,0,0,0-1.18,1.11,2.27,2.27,0,0,0,1,1.63,7.47,7.47,0,0,0,2.08.78c-.06.42-.13.86-.23,1.3a14.12,14.12,0,0,1-.74,2.38l-.06.13c0-.16,0-1.08,0-1.14-.07-.82-.7-2.35-1.59-2.56a1.09,1.09,0,0,0-1.29,1,2.25,2.25,0,0,0,.8,1.73,7.76,7.76,0,0,0,2,1,17.79,17.79,0,0,1-1.15,2.2c-.31.53-.65,1.05-1,1.56,0-.21,0-1.06,0-1.13-.08-.81-.7-2.35-1.6-2.55a1.1,1.1,0,0,0-1.29,1,2.28,2.28,0,0,0,.81,1.73,7.37,7.37,0,0,0,2,1l-.48.7c-.52.77-1.05,1.53-1.55,2.3-.17.27-.33.54-.49.81,0-.33,0-.92,0-1-.07-.82-.7-2.35-1.59-2.55a1.08,1.08,0,0,0-1.29,1,2.25,2.25,0,0,0,.8,1.73,7,7,0,0,0,1.95,1c-.27.45-.52.91-.75,1.36-.09.2-.2.4-.28.6l-.25.58c-.16.4-.31.78-.44,1.16-.07.19-.14.37-.2.56.06-.33.15-.85.15-.9.06-.82-.33-2.43-1.18-2.76a1.09,1.09,0,0,0-1.43.76,2.3,2.3,0,0,0,.54,1.84,7.52,7.52,0,0,0,1.83,1.31c-.16.45-.31.9-.44,1.32-.43,1.33-.73,2.46-.93,3.25s-.3,1.25-.3,1.25h0a.33.33,0,0,0,.26.38.32.32,0,0,0,.38-.26s.08-.45.27-1.23.45-1.91.85-3.24c.11-.38.23-.79.37-1.2a7.64,7.64,0,0,0,2.23.26,2.27,2.27,0,0,0,1.63-1,1.1,1.1,0,0,0-.54-1.53c-.86-.32-2.23.62-2.74,1.26l-.53.84c.08-.25.16-.5.25-.76l.41-1.14.24-.59c.08-.2.17-.38.26-.58s.29-.57.44-.85a6.86,6.86,0,0,0,2.07.55,2.28,2.28,0,0,0,1.76-.74,1.09,1.09,0,0,0-.31-1.59c-.8-.45-2.29.27-2.89.82,0,0-.14.15-.27.31.15-.28.31-.55.48-.83.47-.77,1-1.54,1.49-2.32.11-.16.21-.32.31-.49a7.26,7.26,0,0,0,2.13.58,2.29,2.29,0,0,0,1.76-.75,1.08,1.08,0,0,0-.31-1.58c-.8-.46-2.29.26-2.89.82l-.31.35c.27-.42.53-.85.78-1.28a21.34,21.34,0,0,0,1.14-2.3,7.83,7.83,0,0,0,2.18.6,2.27,2.27,0,0,0,1.76-.75A1.09,1.09,0,0,0,422,337.18Z",
    style: {
      fill: "#4819F2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.36,332.31c-.89-.23-2.14.86-2.58,1.55,0,.06-.51,1.07-.5,1.07a7.83,7.83,0,0,0,2.29,0,2.27,2.27,0,0,0,1.5-1.18A1.08,1.08,0,0,0,422.36,332.31Z",
    style: {
      fill: "#4819F2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.92,326.66a9.69,9.69,0,0,0,2.65.92s-.13-1.36-.15-1.45c-.22-1-1.23-2.75-2.36-2.84a1.32,1.32,0,0,0-1.41,1.39A2.79,2.79,0,0,0,398.92,326.66Z",
    style: {
      fill: "#4819F2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,345.5c-1.13,0-2.22,1.76-2.5,2.73,0,0-.12.69-.18,1.1,0-.24,0-.48,0-.73,0-.5,0-1,0-1.52l-.06-.78c0-.26-.06-.53-.09-.8-.08-.62-.19-1.25-.32-1.88a9.06,9.06,0,0,0,2.66-.36,2.8,2.8,0,0,0,1.64-1.69,1.34,1.34,0,0,0-1.11-1.65c-1.12-.13-2.46,1.4-2.88,2.32,0,.06-.25.75-.36,1.13-.08-.38-.16-.76-.25-1.13-.27-1.1-.57-2.2-.87-3.3l-.27-1a9.37,9.37,0,0,0,2.76-.36,2.81,2.81,0,0,0,1.63-1.69,1.33,1.33,0,0,0-1.1-1.65c-1.12-.13-2.46,1.4-2.88,2.32,0,.07-.35,1.06-.42,1.32q-.3-1.11-.54-2.22a24.6,24.6,0,0,1-.45-3,9.27,9.27,0,0,0,2.77-.37,2.78,2.78,0,0,0,1.64-1.68,1.33,1.33,0,0,0-1.11-1.65c-1.12-.13-2.46,1.4-2.87,2.31,0,.08-.38,1.15-.43,1.35a1.1,1.1,0,0,1,0-.18,18.1,18.1,0,0,1,.1-3.06c.07-.56.16-1.09.26-1.6a9.15,9.15,0,0,0,2.73-.07,2.82,2.82,0,0,0,1.81-1.49,1.34,1.34,0,0,0-.92-1.77c-1.1-.25-2.6,1.12-3.12,2,0,.05-.26.56-.42.93.05-.23.1-.47.15-.69.19-.83.41-1.58.62-2.25.11-.37.23-.71.34-1a8.91,8.91,0,0,0,2.38-1.32,2.8,2.8,0,0,0,.92-2.16,1.34,1.34,0,0,0-1.63-1.14c-1.09.29-1.79,2.2-1.85,3.2,0,.09.08,1.46.1,1.45h0c-.12.3-.23.62-.35,1-.22.66-.47,1.41-.67,2.24a23.54,23.54,0,0,0-.55,2.71,17.26,17.26,0,0,0-.17,3.09v0c-.11-.31-.45-1.17-.48-1.24-.48-.88-1.92-2.32-3-2.12a.79.79,0,0,1-1.3,0c-1.11-.2-2.55,1.24-3,2.12l-.49,1.24a.08.08,0,0,0,0,0,17.24,17.24,0,0,0-.18-3.09,21.64,21.64,0,0,0-.54-2.71c-.21-.83-.45-1.58-.67-2.24-.12-.36-.24-.68-.35-1h0s.1-1.36.09-1.45c-.05-1-.75-2.91-1.85-3.2a1.33,1.33,0,0,0-1.62,1.14,2.77,2.77,0,0,0,.92,2.16,8.77,8.77,0,0,0,2.38,1.32c.11.31.22.65.34,1,.21.67.43,1.42.62,2.25.05.22.1.46.15.69-.17-.37-.4-.88-.43-.93-.51-.87-2-2.24-3.11-2a1.34,1.34,0,0,0-.92,1.77,2.8,2.8,0,0,0,1.81,1.49,9.15,9.15,0,0,0,2.73.07c.1.51.19,1,.25,1.6a17.09,17.09,0,0,1,.11,3.06,1.1,1.1,0,0,0,0,.18c-.05-.2-.4-1.27-.43-1.35-.41-.91-1.76-2.44-2.88-2.31a1.33,1.33,0,0,0-1.1,1.65,2.79,2.79,0,0,0,1.63,1.68,9.34,9.34,0,0,0,2.77.37,22.76,22.76,0,0,1-.44,3c-.16.74-.35,1.48-.54,2.22-.07-.26-.39-1.25-.42-1.32-.42-.92-1.76-2.45-2.88-2.32a1.34,1.34,0,0,0-1.11,1.65,2.82,2.82,0,0,0,1.64,1.69,9.31,9.31,0,0,0,2.75.36c-.09.34-.17.68-.26,1-.3,1.1-.61,2.2-.87,3.3-.1.37-.17.75-.25,1.13-.12-.38-.34-1.07-.37-1.13-.41-.92-1.76-2.45-2.88-2.32a1.33,1.33,0,0,0-1.1,1.65,2.81,2.81,0,0,0,1.63,1.69,9.1,9.1,0,0,0,2.66.36c-.12.63-.23,1.26-.31,1.88,0,.27-.08.54-.09.8l-.06.78c0,.53,0,1,0,1.52,0,.25,0,.49,0,.73-.06-.41-.16-1.05-.18-1.1-.27-1-1.37-2.69-2.49-2.73a1.34,1.34,0,0,0-1.35,1.46,2.81,2.81,0,0,0,1.37,1.92,9.11,9.11,0,0,0,2.65.77c0,.6,0,1.18,0,1.72.05,1.72.15,3.15.23,4.15s.16,1.57.16,1.57h0a.4.4,0,0,0,.79-.12s-.09-.55-.19-1.54-.24-2.39-.32-4.09c0-.49,0-1-.06-1.55a9,9,0,0,0,2.7-.6,2.8,2.8,0,0,0,1.49-1.82,1.35,1.35,0,0,0-1.25-1.55c-1.13,0-2.33,1.61-2.67,2.56,0,.06-.19.81-.27,1.19,0-.32,0-.64,0-1s0-1,0-1.49q0-.37,0-.78c0-.26.05-.51.07-.77s.11-.78.17-1.17a8.69,8.69,0,0,0,2.62-.2,2.77,2.77,0,0,0,1.74-1.57,1.34,1.34,0,0,0-1-1.72c-1.11-.2-2.54,1.24-3,2.12,0,0-.1.23-.19.47.07-.38.14-.76.23-1.15.24-1.09.51-2.19.79-3.3.06-.23.11-.46.17-.69a9,9,0,0,0,2.69-.19,2.8,2.8,0,0,0,1.74-1.57,1.33,1.33,0,0,0-1-1.72c-1.11-.2-2.55,1.23-3,2.12l-.21.53c.14-.6.27-1.2.38-1.8a23.07,23.07,0,0,0,.39-3.13,9.32,9.32,0,0,0,2.78-.19,3.46,3.46,0,0,0,1.4-.95,3.46,3.46,0,0,0,1.4.95,9.27,9.27,0,0,0,2.77.19,26.75,26.75,0,0,0,.39,3.13q.18.9.39,1.8c-.1-.26-.2-.5-.22-.53-.47-.89-1.91-2.32-3-2.12a1.34,1.34,0,0,0-1,1.72,2.79,2.79,0,0,0,1.75,1.57,9,9,0,0,0,2.69.19c.06.23.11.46.17.69.27,1.11.55,2.21.79,3.3.09.39.16.77.23,1.15l-.19-.47c-.48-.88-1.92-2.32-3-2.12a1.33,1.33,0,0,0-1,1.72,2.77,2.77,0,0,0,1.74,1.57,8.65,8.65,0,0,0,2.62.2c.06.39.12.78.16,1.17s.06.51.07.77,0,.53,0,.78c0,.5,0,1,0,1.49s0,.66,0,1c-.08-.38-.26-1.13-.28-1.19-.33-.95-1.54-2.59-2.67-2.56a1.34,1.34,0,0,0-1.24,1.55A2.78,2.78,0,0,0,401,349.2a9.07,9.07,0,0,0,2.7.6c0,.54,0,1.06-.05,1.55-.08,1.7-.22,3.11-.32,4.09s-.19,1.54-.19,1.54a.4.4,0,0,0,.33.45.38.38,0,0,0,.45-.33h0s.07-.58.15-1.57.19-2.43.24-4.15c0-.54,0-1.12,0-1.72a9.29,9.29,0,0,0,2.65-.77,2.79,2.79,0,0,0,1.36-1.92A1.33,1.33,0,0,0,407,345.5Z",
    style: {
      fill: "#4819F2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.69,326.66a2.81,2.81,0,0,0,1.26-2,1.32,1.32,0,0,0-1.41-1.39c-1.13.09-2.13,1.86-2.36,2.84,0,.09-.17,1.45-.15,1.45A9.72,9.72,0,0,0,92.69,326.66Z",
    style: {
      fill: "#4819F2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83,348a1.09,1.09,0,0,0-1.38-.84c-.87.3-1.33,1.89-1.32,2.71,0,.05.08.67.13,1l-.29-.75c-.14-.36-.28-.76-.41-1.14-.06-.2-.13-.4-.19-.6s-.11-.41-.17-.62-.14-.62-.2-.94a6.86,6.86,0,0,0,1.94-.88,2.28,2.28,0,0,0,.89-1.7,1.09,1.09,0,0,0-1.25-1c-.9.16-1.59,1.66-1.71,2.48,0,0,0,.2,0,.4,0-.31-.11-.62-.15-.94-.13-.9-.22-1.82-.33-2.74l-.06-.57a7.3,7.3,0,0,0,2-.91,2.3,2.3,0,0,0,.89-1.69,1.08,1.08,0,0,0-1.25-1c-.9.15-1.6,1.66-1.71,2.47,0,0,0,.24,0,.47-.06-.5-.13-1-.21-1.49a21.7,21.7,0,0,0-.58-2.5,7.63,7.63,0,0,0,2.06-.92,2.28,2.28,0,0,0,.89-1.7,1.1,1.1,0,0,0-1.25-1c-.9.16-1.59,1.66-1.71,2.48,0,.05,0,.81,0,1.08v0a14.35,14.35,0,0,0-1-2.31,20.68,20.68,0,0,0-1.18-1.92c-.4-.58-.79-1.08-1.15-1.52-.19-.24-.37-.45-.54-.65h0s-.31-1.07-.34-1.13c-.33-.75-1.4-2-2.32-1.92a1.09,1.09,0,0,0-.92,1.33,2.29,2.29,0,0,0,1.32,1.39,7.3,7.3,0,0,0,2.18.33c.18.21.36.43.56.69.34.44.72,1,1.1,1.53l.31.49-.59-.59c-.63-.51-2.17-1.14-2.94-.64a1.09,1.09,0,0,0-.2,1.61,2.29,2.29,0,0,0,1.81.63,7.29,7.29,0,0,0,2.1-.72c.22.36.44.74.65,1.15a15.06,15.06,0,0,1,.94,2.31l0,.14c-.09-.14-.66-.86-.7-.91-.58-.58-2-1.37-2.85-.95a1.08,1.08,0,0,0-.38,1.57,2.22,2.22,0,0,0,1.72.82,7.45,7.45,0,0,0,2.22-.5,18.67,18.67,0,0,1,.51,2.43c.09.61.16,1.23.22,1.85-.13-.18-.66-.85-.7-.89-.58-.59-2-1.38-2.85-1a1.09,1.09,0,0,0-.38,1.57,2.26,2.26,0,0,0,1.72.83,7.8,7.8,0,0,0,2.21-.5c0,.28.06.56.08.84.08.93.16,1.85.27,2.76,0,.32.08.63.13.94-.2-.26-.56-.72-.6-.76-.58-.58-2-1.37-2.85-1a1.09,1.09,0,0,0-.38,1.57,2.26,2.26,0,0,0,1.72.83,7,7,0,0,0,2.14-.47c.08.51.17,1,.28,1.52.06.21.1.44.16.64l.18.61c.14.41.26.79.4,1.17.06.19.13.37.2.56-.16-.29-.42-.75-.45-.79-.48-.66-1.8-1.66-2.68-1.38a1.1,1.1,0,0,0-.61,1.5,2.31,2.31,0,0,0,1.58,1.08,7.76,7.76,0,0,0,2.25-.16c.17.45.33.9.5,1.3.52,1.3,1,2.37,1.35,3.1s.56,1.16.56,1.16h0a.32.32,0,0,0,.43.13.32.32,0,0,0,.13-.44s-.22-.4-.58-1.13-.86-1.76-1.4-3L80.46,351a7.17,7.17,0,0,0,1.9-1.22A2.24,2.24,0,0,0,83,348Z",
    style: {
      fill: "#4819F2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8,333.42A7.9,7.9,0,0,0,77.57,332a2.29,2.29,0,0,0,.4-1.87,1.08,1.08,0,0,0-1.47-.67c-.83.4-1.1,2-1,2.84C75.51,332.34,75.78,333.43,75.8,333.42Z",
    style: {
      fill: "#4819F2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.68,326.66a9.69,9.69,0,0,0,2.65.92s-.13-1.36-.14-1.45c-.23-1-1.24-2.75-2.36-2.84a1.32,1.32,0,0,0-1.41,1.39A2.78,2.78,0,0,0,96.68,326.66Z",
    style: {
      fill: "#4819F2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.75,345.5c-1.13,0-2.23,1.76-2.5,2.73,0,0-.12.69-.18,1.1v-.73c0-.5,0-1,0-1.52,0-.26,0-.52,0-.78s-.06-.53-.09-.8c-.08-.62-.2-1.25-.32-1.88a9.1,9.1,0,0,0,2.66-.36,2.81,2.81,0,0,0,1.63-1.69,1.33,1.33,0,0,0-1.1-1.65c-1.12-.13-2.46,1.4-2.88,2.32,0,.06-.25.75-.37,1.13-.08-.38-.15-.76-.25-1.13-.26-1.1-.57-2.2-.86-3.3-.1-.33-.18-.67-.27-1a9.27,9.27,0,0,0,2.75-.36,2.8,2.8,0,0,0,1.64-1.69,1.33,1.33,0,0,0-1.11-1.65c-1.12-.13-2.46,1.4-2.88,2.32,0,.07-.35,1.06-.42,1.32-.19-.74-.38-1.48-.53-2.22a22.81,22.81,0,0,1-.45-3,9.3,9.3,0,0,0,2.77-.37,2.79,2.79,0,0,0,1.63-1.68,1.32,1.32,0,0,0-1.1-1.65c-1.12-.13-2.46,1.4-2.88,2.31,0,.08-.38,1.15-.43,1.35a1.1,1.1,0,0,0,0-.18,18.08,18.08,0,0,1,.11-3.06c.06-.56.15-1.09.25-1.6a9.15,9.15,0,0,0,2.73-.07A2.78,2.78,0,0,0,104,326.2a1.34,1.34,0,0,0-.92-1.77c-1.09-.25-2.6,1.12-3.11,2,0,.05-.26.56-.42.93,0-.23.09-.47.14-.69.19-.83.42-1.58.62-2.25.12-.37.23-.71.35-1a9.07,9.07,0,0,0,2.38-1.32,2.76,2.76,0,0,0,.91-2.16,1.33,1.33,0,0,0-1.62-1.14c-1.09.29-1.8,2.2-1.85,3.2,0,.09.07,1.46.09,1.45h0c-.11.3-.23.62-.35,1-.22.66-.46,1.41-.67,2.24a23.61,23.61,0,0,0-.54,2.71,18.22,18.22,0,0,0-.18,3.09s0,0,0,0c-.11-.31-.46-1.17-.49-1.24-.47-.88-1.91-2.32-3-2.12a1.3,1.3,0,0,0-.66.34,1.27,1.27,0,0,0-.65-.34c-1.11-.2-2.55,1.24-3,2.12,0,.07-.38.93-.49,1.24v0a17.26,17.26,0,0,0-.17-3.09,23.61,23.61,0,0,0-.54-2.71c-.21-.83-.45-1.58-.67-2.24-.13-.36-.24-.68-.36-1h0s.09-1.36.09-1.45c-.06-1-.76-2.91-1.85-3.2a1.34,1.34,0,0,0-1.63,1.14,2.8,2.8,0,0,0,.92,2.16,8.91,8.91,0,0,0,2.38,1.32c.11.31.23.65.35,1,.2.67.43,1.42.62,2.25,0,.22.09.46.14.69-.16-.37-.39-.88-.42-.93-.52-.87-2-2.24-3.12-2a1.34,1.34,0,0,0-.91,1.77,2.78,2.78,0,0,0,1.81,1.49,9.15,9.15,0,0,0,2.73.07c.1.51.19,1,.25,1.6a17.12,17.12,0,0,1,.1,3.06,1.1,1.1,0,0,1,0,.18c0-.2-.39-1.27-.42-1.35-.42-.91-1.76-2.44-2.88-2.31a1.33,1.33,0,0,0-1.11,1.65,2.78,2.78,0,0,0,1.64,1.68,9.3,9.3,0,0,0,2.77.37,22.81,22.81,0,0,1-.45,3c-.15.74-.34,1.48-.54,2.22-.06-.26-.39-1.25-.42-1.32-.41-.92-1.76-2.45-2.88-2.32a1.33,1.33,0,0,0-1.1,1.65,2.81,2.81,0,0,0,1.63,1.69,9.37,9.37,0,0,0,2.76.36l-.27,1c-.3,1.1-.6,2.2-.87,3.3-.09.37-.17.75-.25,1.13-.11-.38-.34-1.07-.36-1.13-.42-.92-1.76-2.45-2.88-2.32a1.34,1.34,0,0,0-1.11,1.65,2.82,2.82,0,0,0,1.64,1.69,9.06,9.06,0,0,0,2.66.36c-.13.63-.24,1.26-.32,1.88,0,.27-.08.54-.09.8l-.05.78c0,.53,0,1,0,1.52v.73c-.06-.41-.17-1.05-.18-1.1-.28-1-1.37-2.69-2.5-2.73A1.33,1.33,0,0,0,83.28,347a2.79,2.79,0,0,0,1.36,1.92,9.25,9.25,0,0,0,2.66.77c0,.6,0,1.18,0,1.72,0,1.72.14,3.15.23,4.15s.16,1.57.16,1.57h0a.38.38,0,0,0,.45.33.4.4,0,0,0,.33-.45s-.08-.55-.19-1.54-.23-2.39-.32-4.09c0-.49,0-1,0-1.55a9.07,9.07,0,0,0,2.7-.6,2.78,2.78,0,0,0,1.48-1.82,1.34,1.34,0,0,0-1.24-1.55c-1.13,0-2.34,1.61-2.67,2.56,0,.06-.19.81-.27,1.19,0-.32,0-.64,0-1s0-1,0-1.49c0-.25,0-.51,0-.78s.05-.51.07-.77.1-.78.16-1.17a8.65,8.65,0,0,0,2.62-.2,2.77,2.77,0,0,0,1.74-1.57,1.33,1.33,0,0,0-1-1.72c-1.11-.2-2.55,1.24-3,2.12,0,0-.1.23-.19.47.07-.38.14-.76.22-1.15.24-1.09.52-2.19.79-3.3.06-.23.12-.46.17-.69a9.06,9.06,0,0,0,2.7-.19A2.8,2.8,0,0,0,94,336.59a1.34,1.34,0,0,0-1-1.72c-1.11-.2-2.55,1.23-3,2.12,0,0-.11.27-.22.53q.21-.9.39-1.8a23.07,23.07,0,0,0,.39-3.13,9.27,9.27,0,0,0,2.77-.19,3.4,3.4,0,0,0,1.4-.95,3.46,3.46,0,0,0,1.4.95,9.32,9.32,0,0,0,2.78.19,23.07,23.07,0,0,0,.39,3.13c.11.6.25,1.2.39,1.8-.11-.26-.2-.5-.22-.53-.48-.89-1.92-2.32-3-2.12a1.33,1.33,0,0,0-1,1.72,2.8,2.8,0,0,0,1.74,1.57,9.06,9.06,0,0,0,2.7.19c0,.23.11.46.16.69.28,1.11.56,2.21.8,3.3.08.39.15.77.22,1.15-.09-.24-.17-.44-.19-.47-.47-.88-1.91-2.32-3-2.12a1.34,1.34,0,0,0-1,1.72,2.77,2.77,0,0,0,1.74,1.57,8.69,8.69,0,0,0,2.62.2c.07.39.13.78.17,1.17s.06.51.07.77,0,.53,0,.78c0,.5,0,1,0,1.49s0,.66,0,1c-.08-.38-.25-1.13-.27-1.19-.34-.95-1.54-2.59-2.67-2.56a1.34,1.34,0,0,0-1.24,1.55,2.78,2.78,0,0,0,1.48,1.82,9,9,0,0,0,2.7.6c0,.54,0,1.06-.06,1.55-.08,1.7-.21,3.11-.32,4.09s-.18,1.54-.18,1.54a.39.39,0,0,0,.78.12h0s.07-.58.16-1.57.19-2.43.23-4.15c0-.54,0-1.12,0-1.72a9.25,9.25,0,0,0,2.66-.77,2.82,2.82,0,0,0,1.36-1.92A1.33,1.33,0,0,0,104.75,345.5Z",
    style: {
      fill: "#4819F2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.12,327.55s.13-1.36.13-1.45c0-1-.69-2.93-1.78-3.24a1.34,1.34,0,0,0-1.65,1.1,2.78,2.78,0,0,0,.87,2.18A9.62,9.62,0,0,0,112.12,327.55Z",
    style: {
      fill: "#4819F2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.67,324.62c.19-.34.36-.65.53-.94a9,9,0,0,0,2.59-.84,2.8,2.8,0,0,0,1.31-1.95,1.33,1.33,0,0,0-1.38-1.42c-1.13.07-2.18,1.81-2.43,2.79,0,.08-.2,1.44-.18,1.44h0l-.53.9c-.34.6-.71,1.29-1.08,2.07a23.88,23.88,0,0,0-1,2.56,16.88,16.88,0,0,0-.76,3v0c0-.33-.23-1.24-.25-1.31-.3-1-1.44-2.64-2.57-2.65a1.33,1.33,0,0,0-1.3,1.5,2.79,2.79,0,0,0,1.42,1.87,9.1,9.1,0,0,0,2.69.71,21.6,21.6,0,0,0-.21,3.14c0,.62,0,1.23,0,1.85-.06-.28-.11-.53-.12-.56-.3-1-1.44-2.65-2.57-2.66a1.33,1.33,0,0,0-1.3,1.5,2.77,2.77,0,0,0,1.42,1.87,8.65,8.65,0,0,0,2.61.7l0,.71c.06,1.14.13,2.28.16,3.39,0,.4,0,.78,0,1.17,0-.25-.09-.46-.1-.49-.3-1-1.44-2.65-2.57-2.66a1.34,1.34,0,0,0-1.3,1.5,2.78,2.78,0,0,0,1.41,1.88,8.61,8.61,0,0,0,2.54.68c0,.4,0,.8-.06,1.18s0,.52-.08.78-.07.52-.11.77c-.09.49-.17,1-.27,1.47-.06.33-.13.64-.2.95,0-.39,0-1.15,0-1.22-.15-1-1-2.83-2.14-3a1.33,1.33,0,0,0-1.51,1.28,2.78,2.78,0,0,0,1.11,2.07,9,9,0,0,0,2.53,1.1c-.11.52-.23,1-.34,1.51-.4,1.65-.8,3-1.09,4s-.48,1.48-.48,1.48a.4.4,0,0,0,.75.26h0s.19-.55.46-1.52.64-2.35,1-4c.12-.53.23-1.1.34-1.69a9.22,9.22,0,0,0,2.76-.26,2.81,2.81,0,0,0,1.7-1.62,1.34,1.34,0,0,0-1-1.69c-1.12-.17-2.52,1.31-3,2.21,0,.05-.25.66-.39,1.05,0-.24.1-.48.14-.72.09-.49.16-1,.24-1.51l.09-.77c0-.26,0-.53.07-.8,0-.63,0-1.27,0-1.91a8.69,8.69,0,0,0,2.68.15,2.83,2.83,0,0,0,1.93-1.35,1.34,1.34,0,0,0-.78-1.83c-1.07-.34-2.68.91-3.26,1.73,0,.05-.39.69-.58,1.05q0-.59,0-1.17c0-1.12-.14-2.26-.23-3.39,0-.35,0-.7-.07-1.05a9.3,9.3,0,0,0,2.78.17,2.79,2.79,0,0,0,1.92-1.35,1.34,1.34,0,0,0-.77-1.83c-1.08-.34-2.69.91-3.27,1.73,0,.06-.54,1-.66,1.22-.05-.76-.1-1.53-.11-2.28a23.32,23.32,0,0,1,.13-3,9.74,9.74,0,0,0,2.79.16,2.81,2.81,0,0,0,1.93-1.34,1.34,1.34,0,0,0-.78-1.83c-1.07-.34-2.68.9-3.26,1.73,0,.06-.59,1.05-.67,1.23a1,1,0,0,1,0-.17,16.67,16.67,0,0,1,.68-3c.17-.54.36-1,.55-1.53a9.33,9.33,0,0,0,2.7.45,2.83,2.83,0,0,0,2.06-1.13,1.34,1.34,0,0,0-.57-1.9c-1-.46-2.77.61-3.44,1.36l-.59.83c.09-.21.18-.44.28-.65C113,325.93,113.34,325.24,113.67,324.62Z",
    style: {
      fill: "#4819F2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.26,352.24S214,319,205.44,309.06,180.08,295,180.08,291.92c0-5.15,21.24,8.23,17.13,4.46s-35.64-24-27.76-23.3,23,13,28.1,15.42-5.14-15.42-13-22.28-13.71-14.73-7.54-12.68,17.82,12,24.68,22.28,11.65,21.59,10.62,14.05-10.28-26.05-6.85-24,12,19.53,13.36,28.44,1.71,8.57,2.06,12.68,1.37-21.59,4.45-15.42,3.09,13.37,3.09,15.77,5.14-8.57,5.14-3.09-1,12.34-1,13.37,11-24,12.34-21.94-1,8.91-1,8.91,25-29.47,24-23.64-7.54,14.73-6.51,16.1,34.27-24.33,30.5-17.47-12.34,11.65-9.94,12.68,30.84-4.12,27.41-.35-23,1.72-24.33,5.49,30.63,9,30.91,13.91-29.54-6-33.65-6.37,16.45,8.91,15.42,13.7-23.3-8.91-24.67-9.25,5.14,5.48,2.4,7.2-9.6-2.06-16.45-1.72-2.06,3.77-2.4,6.17-8.91-1.37-13.37-.34,7.2,4.46,3.43,6.17-12.34,5.82-12.68,7.54,21.93-4.46,19.19-1.37-8.91,6.17-8.22,8.22,9.59-6.51,9.25-1-.34,7.2,1,5.14,5.14-20.56,6.85-16.1.69,15.08.69,15.08,7.19-8.57,6.16-4.46a23.48,23.48,0,0,1-4.11,7.88s14.4-3.77,9.6-1-18.51,7.88-18.51,7.88Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.45,326.66a2.79,2.79,0,0,0,1.27-2,1.33,1.33,0,0,0-1.42-1.39c-1.12.09-2.13,1.86-2.35,2.84,0,.09-.17,1.45-.15,1.45A9.69,9.69,0,0,0,326.45,326.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.74,348a1.09,1.09,0,0,0-1.39-.84c-.87.3-1.32,1.89-1.31,2.71,0,.05.08.67.12,1-.09-.25-.19-.49-.28-.75s-.28-.76-.42-1.14c-.06-.2-.12-.4-.19-.6s-.11-.41-.16-.62-.14-.62-.21-.94a6.91,6.91,0,0,0,2-.88,2.27,2.27,0,0,0,.88-1.7,1.08,1.08,0,0,0-1.24-1c-.9.16-1.6,1.66-1.71,2.48,0,0,0,.2,0,.4l-.15-.94c-.12-.9-.22-1.82-.32-2.74,0-.19-.05-.38-.07-.57a7.17,7.17,0,0,0,2-.91,2.27,2.27,0,0,0,.89-1.69,1.08,1.08,0,0,0-1.24-1c-.91.15-1.6,1.66-1.71,2.47,0,0,0,.24,0,.47-.06-.5-.13-1-.22-1.49a18.21,18.21,0,0,0-.58-2.5,7.53,7.53,0,0,0,2.07-.92,2.27,2.27,0,0,0,.88-1.7,1.08,1.08,0,0,0-1.24-1c-.91.16-1.6,1.66-1.71,2.48,0,.05,0,.81,0,1.07v0a13.53,13.53,0,0,0-1-2.31,17.12,17.12,0,0,0-1.18-1.92c-.39-.58-.79-1.08-1.14-1.52-.19-.24-.38-.45-.55-.65h0s-.31-1.07-.33-1.13c-.33-.75-1.41-2-2.32-1.92a1.08,1.08,0,0,0-.92,1.33,2.3,2.3,0,0,0,1.31,1.39,7.41,7.41,0,0,0,2.19.33c.17.21.36.43.55.69.35.44.73,1,1.11,1.53l.3.49-.58-.59c-.64-.51-2.17-1.14-2.94-.64a1.09,1.09,0,0,0-.2,1.61,2.27,2.27,0,0,0,1.8.63,7.18,7.18,0,0,0,2.1-.72,11.47,11.47,0,0,1,.65,1.15,13.28,13.28,0,0,1,.94,2.31s0,.09,0,.14c-.1-.14-.66-.86-.71-.91-.57-.58-2-1.37-2.85-.95a1.09,1.09,0,0,0-.38,1.57,2.24,2.24,0,0,0,1.73.82,7.62,7.62,0,0,0,2.22-.5,20.48,20.48,0,0,1,.51,2.43c.09.61.15,1.23.21,1.85-.12-.18-.65-.85-.69-.89-.58-.59-2-1.38-2.86-1a1.08,1.08,0,0,0-.37,1.57,2.26,2.26,0,0,0,1.72.83,7.8,7.8,0,0,0,2.21-.5c0,.28.05.56.08.84.08.93.16,1.85.26,2.76,0,.32.09.63.13.94-.19-.26-.56-.72-.59-.76-.58-.58-2-1.37-2.86-1a1.09,1.09,0,0,0-.38,1.57,2.28,2.28,0,0,0,1.73.83,7,7,0,0,0,2.13-.47c.08.51.18,1,.29,1.52.05.21.09.44.16.64s.12.41.17.61c.14.41.26.79.4,1.17.07.19.14.37.2.56-.16-.29-.42-.75-.45-.79-.48-.66-1.8-1.66-2.67-1.38a1.09,1.09,0,0,0-.61,1.5,2.27,2.27,0,0,0,1.58,1.08,7.72,7.72,0,0,0,2.24-.16c.17.45.34.9.5,1.3.52,1.3,1,2.37,1.35,3.1s.57,1.16.57,1.16h0a.32.32,0,1,0,.57-.31s-.22-.4-.58-1.13-.86-1.76-1.4-3q-.24-.56-.48-1.17a7.15,7.15,0,0,0,1.89-1.22A2.29,2.29,0,0,0,316.74,348Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.56,333.42a7.9,7.9,0,0,0,1.77-1.45,2.29,2.29,0,0,0,.41-1.87,1.09,1.09,0,0,0-1.48-.67c-.83.4-1.1,2-1,2.84C309.28,332.34,309.55,333.43,309.56,333.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.48,337.18c-.8-.45-2.29.27-2.9.83l-.7.81v0a14.85,14.85,0,0,0,.7-2.42,19.53,19.53,0,0,0,.3-2.24c.06-.69.08-1.33.09-1.89,0-.31,0-.59,0-.85h0s.44-1,.46-1.09c.23-.79.2-2.44-.56-2.95a1.09,1.09,0,0,0-1.56.44,2.29,2.29,0,0,0,.13,1.91,6.94,6.94,0,0,0,1.48,1.64c0,.27,0,.56,0,.88,0,.57-.05,1.21-.13,1.9,0,.18-.05.38-.07.57,0-.33-.07-.79-.08-.83-.16-.8-.95-2.26-1.86-2.36a1.08,1.08,0,0,0-1.18,1.11,2.31,2.31,0,0,0,1,1.63,7.4,7.4,0,0,0,2.09.78c-.07.42-.14.86-.24,1.3a14.12,14.12,0,0,1-.74,2.38l-.06.13c0-.16,0-1.08,0-1.14-.07-.82-.7-2.35-1.59-2.56a1.09,1.09,0,0,0-1.29,1,2.25,2.25,0,0,0,.8,1.73,7.64,7.64,0,0,0,2,1,19.35,19.35,0,0,1-1.16,2.2c-.31.53-.65,1.05-1,1.56,0-.21,0-1.06,0-1.13-.08-.81-.7-2.35-1.6-2.55a1.1,1.1,0,0,0-1.29,1,2.28,2.28,0,0,0,.81,1.73,7.37,7.37,0,0,0,2,1l-.48.7c-.52.77-1,1.53-1.55,2.3-.17.27-.33.54-.49.81,0-.33,0-.92,0-1-.07-.82-.7-2.35-1.59-2.55a1.08,1.08,0,0,0-1.29,1,2.25,2.25,0,0,0,.8,1.73,7.17,7.17,0,0,0,1.95,1c-.27.45-.52.91-.75,1.36-.09.2-.2.4-.28.6l-.25.58c-.16.4-.31.78-.44,1.16-.07.19-.14.37-.2.56l.16-.9c.05-.82-.34-2.43-1.19-2.76a1.09,1.09,0,0,0-1.43.76,2.3,2.3,0,0,0,.54,1.84,7.52,7.52,0,0,0,1.83,1.31c-.16.45-.31.9-.44,1.32-.43,1.33-.73,2.46-.93,3.25s-.3,1.25-.3,1.25h0a.32.32,0,0,0,.25.38.32.32,0,0,0,.38-.26s.08-.45.27-1.23.45-1.91.85-3.24c.11-.38.23-.79.37-1.2a7.64,7.64,0,0,0,2.23.26,2.25,2.25,0,0,0,1.63-1,1.1,1.1,0,0,0-.54-1.53c-.86-.32-2.22.62-2.74,1.26l-.53.84c.09-.25.17-.5.25-.76l.41-1.14.24-.59c.08-.2.17-.38.26-.58l.44-.85a6.86,6.86,0,0,0,2.07.55,2.28,2.28,0,0,0,1.76-.74,1.09,1.09,0,0,0-.31-1.59c-.8-.45-2.29.27-2.89.82,0,0-.14.15-.27.31.15-.28.31-.55.48-.83.47-.77,1-1.54,1.49-2.32l.32-.49a7.1,7.1,0,0,0,2.12.58,2.29,2.29,0,0,0,1.76-.75,1.08,1.08,0,0,0-.31-1.58c-.8-.46-2.29.26-2.89.82l-.31.35c.27-.42.53-.85.78-1.28a19.64,19.64,0,0,0,1.14-2.3,7.83,7.83,0,0,0,2.18.6,2.27,2.27,0,0,0,1.76-.75A1.09,1.09,0,0,0,353.48,337.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.89,332.31c-.89-.23-2.14.86-2.58,1.55,0,.06-.51,1.07-.5,1.07a7.83,7.83,0,0,0,2.29,0,2.27,2.27,0,0,0,1.5-1.18A1.08,1.08,0,0,0,353.89,332.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.45,326.66a9.69,9.69,0,0,0,2.65.92s-.13-1.36-.15-1.45c-.22-1-1.23-2.75-2.36-2.84a1.32,1.32,0,0,0-1.41,1.39A2.79,2.79,0,0,0,330.45,326.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.51,345.5c-1.13,0-2.22,1.76-2.49,2.73,0,0-.13.69-.18,1.1,0-.24,0-.48,0-.73,0-.5,0-1,0-1.52l-.06-.78c0-.26-.06-.53-.09-.8-.08-.62-.19-1.25-.32-1.88a9.06,9.06,0,0,0,2.66-.36,2.8,2.8,0,0,0,1.64-1.69,1.33,1.33,0,0,0-1.11-1.65c-1.12-.13-2.46,1.4-2.88,2.32,0,.06-.25.75-.36,1.13-.08-.38-.16-.76-.25-1.13-.27-1.1-.57-2.2-.87-3.3l-.27-1a9.37,9.37,0,0,0,2.76-.36,2.81,2.81,0,0,0,1.63-1.69,1.33,1.33,0,0,0-1.1-1.65c-1.12-.13-2.46,1.4-2.88,2.32,0,.07-.35,1.06-.42,1.32q-.3-1.11-.54-2.22a24.6,24.6,0,0,1-.45-3,9.27,9.27,0,0,0,2.77-.37,2.78,2.78,0,0,0,1.64-1.68,1.33,1.33,0,0,0-1.11-1.65c-1.12-.13-2.46,1.4-2.87,2.31,0,.08-.38,1.15-.43,1.35a1.1,1.1,0,0,1,0-.18,18.1,18.1,0,0,1,.1-3.06c.07-.56.16-1.09.26-1.6a9.15,9.15,0,0,0,2.73-.07,2.82,2.82,0,0,0,1.81-1.49,1.34,1.34,0,0,0-.92-1.77c-1.1-.25-2.6,1.12-3.12,2l-.42.93c.05-.23.1-.47.15-.69.19-.83.41-1.58.62-2.25.11-.37.23-.71.34-1a8.91,8.91,0,0,0,2.38-1.32,2.8,2.8,0,0,0,.92-2.16,1.34,1.34,0,0,0-1.63-1.14c-1.09.29-1.79,2.2-1.85,3.2,0,.09.08,1.46.1,1.45h0c-.11.3-.23.62-.35,1-.22.66-.46,1.41-.67,2.24a23.54,23.54,0,0,0-.55,2.71,17.26,17.26,0,0,0-.17,3.09v0c-.11-.31-.45-1.17-.48-1.24-.48-.88-1.92-2.32-3-2.12a.79.79,0,0,1-1.3,0c-1.11-.2-2.55,1.24-3,2.12,0,.07-.37.93-.48,1.24v0a17.26,17.26,0,0,0-.17-3.09,23.54,23.54,0,0,0-.55-2.71c-.21-.83-.45-1.58-.67-2.24-.12-.36-.24-.68-.35-1h0s.1-1.36.09-1.45c-.05-1-.75-2.91-1.85-3.2a1.33,1.33,0,0,0-1.62,1.14,2.77,2.77,0,0,0,.92,2.16,8.77,8.77,0,0,0,2.38,1.32c.11.31.22.65.34,1,.21.67.43,1.42.62,2.25.05.22.1.46.15.69-.17-.37-.4-.88-.43-.93-.51-.87-2-2.24-3.11-2a1.34,1.34,0,0,0-.92,1.77,2.8,2.8,0,0,0,1.81,1.49,9.15,9.15,0,0,0,2.73.07c.1.51.19,1,.25,1.6a17.09,17.09,0,0,1,.11,3.06,1.1,1.1,0,0,0,0,.18c0-.2-.4-1.27-.43-1.35-.41-.91-1.76-2.44-2.88-2.31a1.33,1.33,0,0,0-1.1,1.65,2.79,2.79,0,0,0,1.63,1.68,9.34,9.34,0,0,0,2.77.37,22.76,22.76,0,0,1-.44,3c-.16.74-.35,1.48-.54,2.22-.07-.26-.39-1.25-.42-1.32-.42-.92-1.76-2.45-2.88-2.32a1.34,1.34,0,0,0-1.11,1.65,2.82,2.82,0,0,0,1.64,1.69,9.31,9.31,0,0,0,2.75.36c-.09.34-.17.68-.26,1-.3,1.1-.61,2.2-.87,3.3-.09.37-.17.75-.25,1.13-.12-.38-.34-1.07-.37-1.13-.41-.92-1.76-2.45-2.88-2.32a1.33,1.33,0,0,0-1.1,1.65,2.81,2.81,0,0,0,1.63,1.69,9.1,9.1,0,0,0,2.66.36c-.12.63-.23,1.26-.31,1.88,0,.27-.08.54-.09.8l-.06.78c0,.53,0,1,0,1.52,0,.25,0,.49,0,.73-.06-.41-.16-1.05-.18-1.1-.27-1-1.37-2.69-2.49-2.73A1.35,1.35,0,0,0,317,347a2.81,2.81,0,0,0,1.37,1.92,9.2,9.2,0,0,0,2.65.77c0,.6,0,1.18,0,1.72.05,1.72.15,3.15.23,4.15s.16,1.57.16,1.57h0a.4.4,0,0,0,.79-.12s-.09-.55-.19-1.54-.24-2.39-.32-4.09c0-.49,0-1-.06-1.55a9,9,0,0,0,2.7-.6,2.8,2.8,0,0,0,1.49-1.82,1.35,1.35,0,0,0-1.25-1.55c-1.12,0-2.33,1.61-2.67,2.56,0,.06-.19.81-.27,1.19,0-.32,0-.64,0-1s0-1,0-1.49l0-.78c0-.26,0-.51.07-.77s.11-.78.17-1.17a8.69,8.69,0,0,0,2.62-.2,2.77,2.77,0,0,0,1.74-1.57,1.34,1.34,0,0,0-1-1.72c-1.11-.2-2.55,1.24-3,2.12,0,0-.1.23-.19.47.07-.38.14-.76.23-1.15.24-1.09.52-2.19.79-3.3.06-.23.11-.46.17-.69a9,9,0,0,0,2.69-.19,2.8,2.8,0,0,0,1.74-1.57,1.33,1.33,0,0,0-1-1.72c-1.11-.2-2.55,1.23-3,2.12l-.21.53c.14-.6.27-1.2.38-1.8a23.07,23.07,0,0,0,.39-3.13,9.32,9.32,0,0,0,2.78-.19,3.46,3.46,0,0,0,1.4-.95,3.46,3.46,0,0,0,1.4.95,9.27,9.27,0,0,0,2.77.19,24.83,24.83,0,0,0,.4,3.13c.11.6.24,1.2.38,1.8-.1-.26-.2-.5-.22-.53-.47-.89-1.91-2.32-3-2.12a1.34,1.34,0,0,0-1,1.72,2.79,2.79,0,0,0,1.75,1.57,9,9,0,0,0,2.69.19c.06.23.11.46.17.69.27,1.11.55,2.21.79,3.3.09.39.16.77.23,1.15l-.19-.47c-.48-.88-1.92-2.32-3-2.12a1.33,1.33,0,0,0-1,1.72,2.77,2.77,0,0,0,1.74,1.57,8.65,8.65,0,0,0,2.62.2c.06.39.12.78.16,1.17a6.68,6.68,0,0,1,.07.77c0,.27,0,.53,0,.78,0,.5,0,1,0,1.49s0,.66,0,1c-.08-.38-.26-1.13-.28-1.19-.33-.95-1.54-2.59-2.66-2.56a1.34,1.34,0,0,0-1.25,1.55,2.77,2.77,0,0,0,1.49,1.82,9,9,0,0,0,2.69.6c0,.54,0,1.06-.05,1.55-.08,1.7-.21,3.11-.32,4.09s-.19,1.54-.19,1.54a.4.4,0,0,0,.33.45.38.38,0,0,0,.45-.33h0s.07-.58.15-1.57.19-2.43.24-4.15c0-.54,0-1.12,0-1.72a9.2,9.2,0,0,0,2.65-.77,2.79,2.79,0,0,0,1.36-1.92A1.33,1.33,0,0,0,338.51,345.5Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.92,326.66a2.79,2.79,0,0,0,1.27-2,1.33,1.33,0,0,0-1.42-1.39c-1.12.09-2.13,1.86-2.35,2.84,0,.09-.17,1.45-.15,1.45A9.69,9.69,0,0,0,394.92,326.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.21,348a1.09,1.09,0,0,0-1.39-.84c-.87.3-1.33,1.89-1.31,2.71,0,.05.08.67.12,1-.09-.25-.19-.49-.28-.75s-.28-.76-.42-1.14l-.19-.6c-.07-.21-.11-.41-.16-.62s-.14-.62-.21-.94a7,7,0,0,0,1.95-.88,2.27,2.27,0,0,0,.88-1.7,1.08,1.08,0,0,0-1.24-1c-.91.16-1.6,1.66-1.71,2.48,0,0,0,.2,0,.4l-.15-.94c-.12-.9-.22-1.82-.32-2.74,0-.19-.05-.38-.07-.57a7.17,7.17,0,0,0,2-.91,2.27,2.27,0,0,0,.89-1.69,1.08,1.08,0,0,0-1.24-1c-.91.15-1.6,1.66-1.71,2.47a3.59,3.59,0,0,0,0,.47c-.06-.5-.13-1-.22-1.49a18.21,18.21,0,0,0-.58-2.5,7.66,7.66,0,0,0,2.07-.92,2.27,2.27,0,0,0,.88-1.7,1.08,1.08,0,0,0-1.24-1c-.91.16-1.6,1.66-1.71,2.48,0,.05,0,.81,0,1.07v0a13.53,13.53,0,0,0-1-2.31,17.12,17.12,0,0,0-1.18-1.92c-.39-.58-.79-1.08-1.14-1.52-.19-.24-.38-.45-.55-.65h0s-.31-1.07-.34-1.13c-.32-.75-1.4-2-2.31-1.92a1.08,1.08,0,0,0-.92,1.33,2.3,2.3,0,0,0,1.31,1.39,7.41,7.41,0,0,0,2.19.33l.55.69c.34.44.73,1,1.11,1.53l.3.49-.58-.59c-.64-.51-2.17-1.14-2.94-.64a1.09,1.09,0,0,0-.2,1.61,2.27,2.27,0,0,0,1.8.63,7.18,7.18,0,0,0,2.1-.72c.23.36.44.74.65,1.15a14.11,14.11,0,0,1,.94,2.31s0,.09,0,.14c-.1-.14-.66-.86-.71-.91-.57-.58-2-1.37-2.85-.95a1.09,1.09,0,0,0-.38,1.57,2.24,2.24,0,0,0,1.73.82,7.62,7.62,0,0,0,2.22-.5,18.66,18.66,0,0,1,.5,2.43c.09.61.16,1.23.22,1.85-.12-.18-.65-.85-.69-.89-.58-.59-2-1.38-2.86-1a1.08,1.08,0,0,0-.37,1.57,2.25,2.25,0,0,0,1.72.83,7.8,7.8,0,0,0,2.21-.5c0,.28.05.56.08.84.08.93.16,1.85.26,2.76,0,.32.09.63.13.94-.19-.26-.56-.72-.6-.76-.57-.58-2-1.37-2.85-1a1.09,1.09,0,0,0-.38,1.57,2.28,2.28,0,0,0,1.73.83,7,7,0,0,0,2.13-.47c.08.51.18,1,.29,1.52.05.21.09.44.16.64s.12.41.17.61c.14.41.26.79.4,1.17.07.19.14.37.2.56-.16-.29-.42-.75-.45-.79-.48-.66-1.8-1.66-2.67-1.38a1.09,1.09,0,0,0-.61,1.5,2.27,2.27,0,0,0,1.58,1.08,7.72,7.72,0,0,0,2.24-.16c.17.45.34.9.5,1.3.52,1.3,1,2.37,1.35,3.1s.57,1.16.57,1.16h0a.32.32,0,1,0,.57-.31s-.22-.4-.58-1.13-.86-1.76-1.4-3q-.24-.56-.48-1.17a7.15,7.15,0,0,0,1.89-1.22A2.29,2.29,0,0,0,385.21,348Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378,333.42A7.9,7.9,0,0,0,379.8,332a2.29,2.29,0,0,0,.41-1.87,1.09,1.09,0,0,0-1.48-.67c-.83.4-1.1,2-1,2.84C377.75,332.34,378,333.43,378,333.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422,337.18c-.8-.45-2.29.27-2.9.83l-.7.81v0a13.86,13.86,0,0,0,.69-2.42,17.64,17.64,0,0,0,.31-2.24c.06-.69.08-1.33.09-1.89,0-.31,0-.59,0-.85h0s.44-1,.46-1.09c.23-.79.2-2.44-.57-2.95a1.08,1.08,0,0,0-1.55.44,2.29,2.29,0,0,0,.13,1.91,6.94,6.94,0,0,0,1.48,1.64c0,.27,0,.56,0,.88,0,.57-.05,1.21-.13,1.9,0,.18-.05.38-.07.57,0-.33-.07-.79-.08-.83-.16-.8-.95-2.26-1.86-2.36a1.08,1.08,0,0,0-1.18,1.11,2.27,2.27,0,0,0,1,1.63,7.47,7.47,0,0,0,2.08.78c-.06.42-.13.86-.23,1.3a14.12,14.12,0,0,1-.74,2.38l-.06.13c0-.16,0-1.08,0-1.14-.07-.82-.7-2.35-1.59-2.56a1.09,1.09,0,0,0-1.29,1,2.25,2.25,0,0,0,.8,1.73,7.76,7.76,0,0,0,2,1,17.79,17.79,0,0,1-1.15,2.2c-.31.53-.65,1.05-1,1.56,0-.21,0-1.06,0-1.13-.08-.81-.7-2.35-1.6-2.55a1.1,1.1,0,0,0-1.29,1,2.28,2.28,0,0,0,.81,1.73,7.37,7.37,0,0,0,2,1l-.48.7c-.52.77-1.05,1.53-1.55,2.3-.17.27-.33.54-.49.81,0-.33,0-.92,0-1-.07-.82-.7-2.35-1.59-2.55a1.08,1.08,0,0,0-1.29,1,2.25,2.25,0,0,0,.8,1.73,7,7,0,0,0,1.95,1c-.27.45-.52.91-.75,1.36-.09.2-.2.4-.28.6l-.25.58c-.16.4-.31.78-.44,1.16-.07.19-.14.37-.2.56.06-.33.15-.85.15-.9.06-.82-.33-2.43-1.18-2.76a1.09,1.09,0,0,0-1.43.76,2.3,2.3,0,0,0,.54,1.84,7.52,7.52,0,0,0,1.83,1.31c-.16.45-.31.9-.44,1.32-.43,1.33-.73,2.46-.93,3.25s-.3,1.25-.3,1.25h0a.33.33,0,0,0,.26.38.32.32,0,0,0,.38-.26s.08-.45.27-1.23.45-1.91.85-3.24c.11-.38.23-.79.37-1.2a7.64,7.64,0,0,0,2.23.26,2.27,2.27,0,0,0,1.63-1,1.1,1.1,0,0,0-.54-1.53c-.86-.32-2.23.62-2.74,1.26l-.53.84c.08-.25.16-.5.25-.76l.41-1.14.24-.59c.08-.2.17-.38.26-.58s.29-.57.44-.85a6.86,6.86,0,0,0,2.07.55,2.28,2.28,0,0,0,1.76-.74,1.09,1.09,0,0,0-.31-1.59c-.8-.45-2.29.27-2.89.82,0,0-.14.15-.27.31.15-.28.31-.55.48-.83.47-.77,1-1.54,1.49-2.32.11-.16.21-.32.31-.49a7.26,7.26,0,0,0,2.13.58,2.29,2.29,0,0,0,1.76-.75,1.08,1.08,0,0,0-.31-1.58c-.8-.46-2.29.26-2.89.82l-.31.35c.27-.42.53-.85.78-1.28a21.34,21.34,0,0,0,1.14-2.3,7.83,7.83,0,0,0,2.18.6,2.27,2.27,0,0,0,1.76-.75A1.09,1.09,0,0,0,422,337.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.36,332.31c-.89-.23-2.14.86-2.58,1.55,0,.06-.51,1.07-.5,1.07a7.83,7.83,0,0,0,2.29,0,2.27,2.27,0,0,0,1.5-1.18A1.08,1.08,0,0,0,422.36,332.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.92,326.66a9.69,9.69,0,0,0,2.65.92s-.13-1.36-.15-1.45c-.22-1-1.23-2.75-2.36-2.84a1.32,1.32,0,0,0-1.41,1.39A2.79,2.79,0,0,0,398.92,326.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,345.5c-1.13,0-2.22,1.76-2.5,2.73,0,0-.12.69-.18,1.1,0-.24,0-.48,0-.73,0-.5,0-1,0-1.52l-.06-.78c0-.26-.06-.53-.09-.8-.08-.62-.19-1.25-.32-1.88a9.06,9.06,0,0,0,2.66-.36,2.8,2.8,0,0,0,1.64-1.69,1.34,1.34,0,0,0-1.11-1.65c-1.12-.13-2.46,1.4-2.88,2.32,0,.06-.25.75-.36,1.13-.08-.38-.16-.76-.25-1.13-.27-1.1-.57-2.2-.87-3.3l-.27-1a9.37,9.37,0,0,0,2.76-.36,2.81,2.81,0,0,0,1.63-1.69,1.33,1.33,0,0,0-1.1-1.65c-1.12-.13-2.46,1.4-2.88,2.32,0,.07-.35,1.06-.42,1.32q-.3-1.11-.54-2.22a24.6,24.6,0,0,1-.45-3,9.27,9.27,0,0,0,2.77-.37,2.78,2.78,0,0,0,1.64-1.68,1.33,1.33,0,0,0-1.11-1.65c-1.12-.13-2.46,1.4-2.87,2.31,0,.08-.38,1.15-.43,1.35a1.1,1.1,0,0,1,0-.18,18.1,18.1,0,0,1,.1-3.06c.07-.56.16-1.09.26-1.6a9.15,9.15,0,0,0,2.73-.07,2.82,2.82,0,0,0,1.81-1.49,1.34,1.34,0,0,0-.92-1.77c-1.1-.25-2.6,1.12-3.12,2,0,.05-.26.56-.42.93.05-.23.1-.47.15-.69.19-.83.41-1.58.62-2.25.11-.37.23-.71.34-1a8.91,8.91,0,0,0,2.38-1.32,2.8,2.8,0,0,0,.92-2.16,1.34,1.34,0,0,0-1.63-1.14c-1.09.29-1.79,2.2-1.85,3.2,0,.09.08,1.46.1,1.45h0c-.12.3-.23.62-.35,1-.22.66-.47,1.41-.67,2.24a23.54,23.54,0,0,0-.55,2.71,17.26,17.26,0,0,0-.17,3.09v0c-.11-.31-.45-1.17-.48-1.24-.48-.88-1.92-2.32-3-2.12a.79.79,0,0,1-1.3,0c-1.11-.2-2.55,1.24-3,2.12l-.49,1.24a.08.08,0,0,0,0,0,17.24,17.24,0,0,0-.18-3.09,21.64,21.64,0,0,0-.54-2.71c-.21-.83-.45-1.58-.67-2.24-.12-.36-.24-.68-.35-1h0s.1-1.36.09-1.45c-.05-1-.75-2.91-1.85-3.2a1.33,1.33,0,0,0-1.62,1.14,2.77,2.77,0,0,0,.92,2.16,8.77,8.77,0,0,0,2.38,1.32c.11.31.22.65.34,1,.21.67.43,1.42.62,2.25.05.22.1.46.15.69-.17-.37-.4-.88-.43-.93-.51-.87-2-2.24-3.11-2a1.34,1.34,0,0,0-.92,1.77,2.8,2.8,0,0,0,1.81,1.49,9.15,9.15,0,0,0,2.73.07c.1.51.19,1,.25,1.6a17.09,17.09,0,0,1,.11,3.06,1.1,1.1,0,0,0,0,.18c-.05-.2-.4-1.27-.43-1.35-.41-.91-1.76-2.44-2.88-2.31a1.33,1.33,0,0,0-1.1,1.65,2.79,2.79,0,0,0,1.63,1.68,9.34,9.34,0,0,0,2.77.37,22.76,22.76,0,0,1-.44,3c-.16.74-.35,1.48-.54,2.22-.07-.26-.39-1.25-.42-1.32-.42-.92-1.76-2.45-2.88-2.32a1.34,1.34,0,0,0-1.11,1.65,2.82,2.82,0,0,0,1.64,1.69,9.31,9.31,0,0,0,2.75.36c-.09.34-.17.68-.26,1-.3,1.1-.61,2.2-.87,3.3-.1.37-.17.75-.25,1.13-.12-.38-.34-1.07-.37-1.13-.41-.92-1.76-2.45-2.88-2.32a1.33,1.33,0,0,0-1.1,1.65,2.81,2.81,0,0,0,1.63,1.69,9.1,9.1,0,0,0,2.66.36c-.12.63-.23,1.26-.31,1.88,0,.27-.08.54-.09.8l-.06.78c0,.53,0,1,0,1.52,0,.25,0,.49,0,.73-.06-.41-.16-1.05-.18-1.1-.27-1-1.37-2.69-2.49-2.73a1.34,1.34,0,0,0-1.35,1.46,2.81,2.81,0,0,0,1.37,1.92,9.11,9.11,0,0,0,2.65.77c0,.6,0,1.18,0,1.72.05,1.72.15,3.15.23,4.15s.16,1.57.16,1.57h0a.4.4,0,0,0,.79-.12s-.09-.55-.19-1.54-.24-2.39-.32-4.09c0-.49,0-1-.06-1.55a9,9,0,0,0,2.7-.6,2.8,2.8,0,0,0,1.49-1.82,1.35,1.35,0,0,0-1.25-1.55c-1.13,0-2.33,1.61-2.67,2.56,0,.06-.19.81-.27,1.19,0-.32,0-.64,0-1s0-1,0-1.49q0-.37,0-.78c0-.26.05-.51.07-.77s.11-.78.17-1.17a8.69,8.69,0,0,0,2.62-.2,2.77,2.77,0,0,0,1.74-1.57,1.34,1.34,0,0,0-1-1.72c-1.11-.2-2.54,1.24-3,2.12,0,0-.1.23-.19.47.07-.38.14-.76.23-1.15.24-1.09.51-2.19.79-3.3.06-.23.11-.46.17-.69a9,9,0,0,0,2.69-.19,2.8,2.8,0,0,0,1.74-1.57,1.33,1.33,0,0,0-1-1.72c-1.11-.2-2.55,1.23-3,2.12l-.21.53c.14-.6.27-1.2.38-1.8a23.07,23.07,0,0,0,.39-3.13,9.32,9.32,0,0,0,2.78-.19,3.46,3.46,0,0,0,1.4-.95,3.46,3.46,0,0,0,1.4.95,9.27,9.27,0,0,0,2.77.19,26.75,26.75,0,0,0,.39,3.13q.18.9.39,1.8c-.1-.26-.2-.5-.22-.53-.47-.89-1.91-2.32-3-2.12a1.34,1.34,0,0,0-1,1.72,2.79,2.79,0,0,0,1.75,1.57,9,9,0,0,0,2.69.19c.06.23.11.46.17.69.27,1.11.55,2.21.79,3.3.09.39.16.77.23,1.15l-.19-.47c-.48-.88-1.92-2.32-3-2.12a1.33,1.33,0,0,0-1,1.72,2.77,2.77,0,0,0,1.74,1.57,8.65,8.65,0,0,0,2.62.2c.06.39.12.78.16,1.17s.06.51.07.77,0,.53,0,.78c0,.5,0,1,0,1.49s0,.66,0,1c-.08-.38-.26-1.13-.28-1.19-.33-.95-1.54-2.59-2.67-2.56a1.34,1.34,0,0,0-1.24,1.55A2.78,2.78,0,0,0,401,349.2a9.07,9.07,0,0,0,2.7.6c0,.54,0,1.06-.05,1.55-.08,1.7-.22,3.11-.32,4.09s-.19,1.54-.19,1.54a.4.4,0,0,0,.33.45.38.38,0,0,0,.45-.33h0s.07-.58.15-1.57.19-2.43.24-4.15c0-.54,0-1.12,0-1.72a9.29,9.29,0,0,0,2.65-.77,2.79,2.79,0,0,0,1.36-1.92A1.33,1.33,0,0,0,407,345.5Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.69,326.66a2.81,2.81,0,0,0,1.26-2,1.32,1.32,0,0,0-1.41-1.39c-1.13.09-2.13,1.86-2.36,2.84,0,.09-.17,1.45-.15,1.45A9.72,9.72,0,0,0,92.69,326.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83,348a1.09,1.09,0,0,0-1.38-.84c-.87.3-1.33,1.89-1.32,2.71,0,.05.08.67.13,1l-.29-.75c-.14-.36-.28-.76-.41-1.14-.06-.2-.13-.4-.19-.6s-.11-.41-.17-.62-.14-.62-.2-.94a6.86,6.86,0,0,0,1.94-.88,2.28,2.28,0,0,0,.89-1.7,1.09,1.09,0,0,0-1.25-1c-.9.16-1.59,1.66-1.71,2.48,0,0,0,.2,0,.4,0-.31-.11-.62-.15-.94-.13-.9-.22-1.82-.33-2.74l-.06-.57a7.3,7.3,0,0,0,2-.91,2.3,2.3,0,0,0,.89-1.69,1.08,1.08,0,0,0-1.25-1c-.9.15-1.6,1.66-1.71,2.47,0,0,0,.24,0,.47-.06-.5-.13-1-.21-1.49a21.7,21.7,0,0,0-.58-2.5,7.63,7.63,0,0,0,2.06-.92,2.28,2.28,0,0,0,.89-1.7,1.1,1.1,0,0,0-1.25-1c-.9.16-1.59,1.66-1.71,2.48,0,.05,0,.81,0,1.08v0a14.35,14.35,0,0,0-1-2.31,20.68,20.68,0,0,0-1.18-1.92c-.4-.58-.79-1.08-1.15-1.52-.19-.24-.37-.45-.54-.65h0s-.31-1.07-.34-1.13c-.33-.75-1.4-2-2.32-1.92a1.09,1.09,0,0,0-.92,1.33,2.29,2.29,0,0,0,1.32,1.39,7.3,7.3,0,0,0,2.18.33c.18.21.36.43.56.69.34.44.72,1,1.1,1.53l.31.49-.59-.59c-.63-.51-2.17-1.14-2.94-.64a1.09,1.09,0,0,0-.2,1.61,2.29,2.29,0,0,0,1.81.63,7.29,7.29,0,0,0,2.1-.72c.22.36.44.74.65,1.15a15.06,15.06,0,0,1,.94,2.31l0,.14c-.09-.14-.66-.86-.7-.91-.58-.58-2-1.37-2.85-.95a1.08,1.08,0,0,0-.38,1.57,2.22,2.22,0,0,0,1.72.82,7.45,7.45,0,0,0,2.22-.5,18.67,18.67,0,0,1,.51,2.43c.09.61.16,1.23.22,1.85-.13-.18-.66-.85-.7-.89-.58-.59-2-1.38-2.85-1a1.09,1.09,0,0,0-.38,1.57,2.26,2.26,0,0,0,1.72.83,7.8,7.8,0,0,0,2.21-.5c0,.28.06.56.08.84.08.93.16,1.85.27,2.76,0,.32.08.63.13.94-.2-.26-.56-.72-.6-.76-.58-.58-2-1.37-2.85-1a1.09,1.09,0,0,0-.38,1.57,2.26,2.26,0,0,0,1.72.83,7,7,0,0,0,2.14-.47c.08.51.17,1,.28,1.52.06.21.1.44.16.64l.18.61c.14.41.26.79.4,1.17.06.19.13.37.2.56-.16-.29-.42-.75-.45-.79-.48-.66-1.8-1.66-2.68-1.38a1.1,1.1,0,0,0-.61,1.5,2.31,2.31,0,0,0,1.58,1.08,7.76,7.76,0,0,0,2.25-.16c.17.45.33.9.5,1.3.52,1.3,1,2.37,1.35,3.1s.56,1.16.56,1.16h0a.32.32,0,0,0,.43.13.32.32,0,0,0,.13-.44s-.22-.4-.58-1.13-.86-1.76-1.4-3L80.46,351a7.17,7.17,0,0,0,1.9-1.22A2.24,2.24,0,0,0,83,348Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8,333.42A7.9,7.9,0,0,0,77.57,332a2.29,2.29,0,0,0,.4-1.87,1.08,1.08,0,0,0-1.47-.67c-.83.4-1.1,2-1,2.84C75.51,332.34,75.78,333.43,75.8,333.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.68,326.66a9.69,9.69,0,0,0,2.65.92s-.13-1.36-.14-1.45c-.23-1-1.24-2.75-2.36-2.84a1.32,1.32,0,0,0-1.41,1.39A2.78,2.78,0,0,0,96.68,326.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.75,345.5c-1.13,0-2.23,1.76-2.5,2.73,0,0-.12.69-.18,1.1v-.73c0-.5,0-1,0-1.52,0-.26,0-.52,0-.78s-.06-.53-.09-.8c-.08-.62-.2-1.25-.32-1.88a9.1,9.1,0,0,0,2.66-.36,2.81,2.81,0,0,0,1.63-1.69,1.33,1.33,0,0,0-1.1-1.65c-1.12-.13-2.46,1.4-2.88,2.32,0,.06-.25.75-.37,1.13-.08-.38-.15-.76-.25-1.13-.26-1.1-.57-2.2-.86-3.3-.1-.33-.18-.67-.27-1a9.27,9.27,0,0,0,2.75-.36,2.8,2.8,0,0,0,1.64-1.69,1.33,1.33,0,0,0-1.11-1.65c-1.12-.13-2.46,1.4-2.88,2.32,0,.07-.35,1.06-.42,1.32-.19-.74-.38-1.48-.53-2.22a22.81,22.81,0,0,1-.45-3,9.3,9.3,0,0,0,2.77-.37,2.79,2.79,0,0,0,1.63-1.68,1.32,1.32,0,0,0-1.1-1.65c-1.12-.13-2.46,1.4-2.88,2.31,0,.08-.38,1.15-.43,1.35a1.1,1.1,0,0,0,0-.18,18.08,18.08,0,0,1,.11-3.06c.06-.56.15-1.09.25-1.6a9.15,9.15,0,0,0,2.73-.07A2.78,2.78,0,0,0,104,326.2a1.34,1.34,0,0,0-.92-1.77c-1.09-.25-2.6,1.12-3.11,2,0,.05-.26.56-.42.93,0-.23.09-.47.14-.69.19-.83.42-1.58.62-2.25.12-.37.23-.71.35-1a9.07,9.07,0,0,0,2.38-1.32,2.76,2.76,0,0,0,.91-2.16,1.33,1.33,0,0,0-1.62-1.14c-1.09.29-1.8,2.2-1.85,3.2,0,.09.07,1.46.09,1.45h0c-.11.3-.23.62-.35,1-.22.66-.46,1.41-.67,2.24a23.61,23.61,0,0,0-.54,2.71,18.22,18.22,0,0,0-.18,3.09s0,0,0,0c-.11-.31-.46-1.17-.49-1.24-.47-.88-1.91-2.32-3-2.12a1.3,1.3,0,0,0-.66.34,1.27,1.27,0,0,0-.65-.34c-1.11-.2-2.55,1.24-3,2.12,0,.07-.38.93-.49,1.24v0a17.26,17.26,0,0,0-.17-3.09,23.61,23.61,0,0,0-.54-2.71c-.21-.83-.45-1.58-.67-2.24-.13-.36-.24-.68-.36-1h0s.09-1.36.09-1.45c-.06-1-.76-2.91-1.85-3.2a1.34,1.34,0,0,0-1.63,1.14,2.8,2.8,0,0,0,.92,2.16,8.91,8.91,0,0,0,2.38,1.32c.11.31.23.65.35,1,.2.67.43,1.42.62,2.25,0,.22.09.46.14.69-.16-.37-.39-.88-.42-.93-.52-.87-2-2.24-3.12-2a1.34,1.34,0,0,0-.91,1.77,2.78,2.78,0,0,0,1.81,1.49,9.15,9.15,0,0,0,2.73.07c.1.51.19,1,.25,1.6a17.12,17.12,0,0,1,.1,3.06,1.1,1.1,0,0,1,0,.18c0-.2-.39-1.27-.42-1.35-.42-.91-1.76-2.44-2.88-2.31a1.33,1.33,0,0,0-1.11,1.65,2.78,2.78,0,0,0,1.64,1.68,9.3,9.3,0,0,0,2.77.37,22.81,22.81,0,0,1-.45,3c-.15.74-.34,1.48-.54,2.22-.06-.26-.39-1.25-.42-1.32-.41-.92-1.76-2.45-2.88-2.32a1.33,1.33,0,0,0-1.1,1.65,2.81,2.81,0,0,0,1.63,1.69,9.37,9.37,0,0,0,2.76.36l-.27,1c-.3,1.1-.6,2.2-.87,3.3-.09.37-.17.75-.25,1.13-.11-.38-.34-1.07-.36-1.13-.42-.92-1.76-2.45-2.88-2.32a1.34,1.34,0,0,0-1.11,1.65,2.82,2.82,0,0,0,1.64,1.69,9.06,9.06,0,0,0,2.66.36c-.13.63-.24,1.26-.32,1.88,0,.27-.08.54-.09.8l-.05.78c0,.53,0,1,0,1.52v.73c-.06-.41-.17-1.05-.18-1.1-.28-1-1.37-2.69-2.5-2.73A1.33,1.33,0,0,0,83.28,347a2.79,2.79,0,0,0,1.36,1.92,9.25,9.25,0,0,0,2.66.77c0,.6,0,1.18,0,1.72,0,1.72.14,3.15.23,4.15s.16,1.57.16,1.57h0a.38.38,0,0,0,.45.33.4.4,0,0,0,.33-.45s-.08-.55-.19-1.54-.23-2.39-.32-4.09c0-.49,0-1,0-1.55a9.07,9.07,0,0,0,2.7-.6,2.78,2.78,0,0,0,1.48-1.82,1.34,1.34,0,0,0-1.24-1.55c-1.13,0-2.34,1.61-2.67,2.56,0,.06-.19.81-.27,1.19,0-.32,0-.64,0-1s0-1,0-1.49c0-.25,0-.51,0-.78s.05-.51.07-.77.1-.78.16-1.17a8.65,8.65,0,0,0,2.62-.2,2.77,2.77,0,0,0,1.74-1.57,1.33,1.33,0,0,0-1-1.72c-1.11-.2-2.55,1.24-3,2.12,0,0-.1.23-.19.47.07-.38.14-.76.22-1.15.24-1.09.52-2.19.79-3.3.06-.23.12-.46.17-.69a9.06,9.06,0,0,0,2.7-.19A2.8,2.8,0,0,0,94,336.59a1.34,1.34,0,0,0-1-1.72c-1.11-.2-2.55,1.23-3,2.12,0,0-.11.27-.22.53q.21-.9.39-1.8a23.07,23.07,0,0,0,.39-3.13,9.27,9.27,0,0,0,2.77-.19,3.4,3.4,0,0,0,1.4-.95,3.46,3.46,0,0,0,1.4.95,9.32,9.32,0,0,0,2.78.19,23.07,23.07,0,0,0,.39,3.13c.11.6.25,1.2.39,1.8-.11-.26-.2-.5-.22-.53-.48-.89-1.92-2.32-3-2.12a1.33,1.33,0,0,0-1,1.72,2.8,2.8,0,0,0,1.74,1.57,9.06,9.06,0,0,0,2.7.19c0,.23.11.46.16.69.28,1.11.56,2.21.8,3.3.08.39.15.77.22,1.15-.09-.24-.17-.44-.19-.47-.47-.88-1.91-2.32-3-2.12a1.34,1.34,0,0,0-1,1.72,2.77,2.77,0,0,0,1.74,1.57,8.69,8.69,0,0,0,2.62.2c.07.39.13.78.17,1.17s.06.51.07.77,0,.53,0,.78c0,.5,0,1,0,1.49s0,.66,0,1c-.08-.38-.25-1.13-.27-1.19-.34-.95-1.54-2.59-2.67-2.56a1.34,1.34,0,0,0-1.24,1.55,2.78,2.78,0,0,0,1.48,1.82,9,9,0,0,0,2.7.6c0,.54,0,1.06-.06,1.55-.08,1.7-.21,3.11-.32,4.09s-.18,1.54-.18,1.54a.39.39,0,0,0,.78.12h0s.07-.58.16-1.57.19-2.43.23-4.15c0-.54,0-1.12,0-1.72a9.25,9.25,0,0,0,2.66-.77,2.82,2.82,0,0,0,1.36-1.92A1.33,1.33,0,0,0,104.75,345.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.12,327.55s.13-1.36.13-1.45c0-1-.69-2.93-1.78-3.24a1.34,1.34,0,0,0-1.65,1.1,2.78,2.78,0,0,0,.87,2.18A9.62,9.62,0,0,0,112.12,327.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.67,324.62c.19-.34.36-.65.53-.94a9,9,0,0,0,2.59-.84,2.8,2.8,0,0,0,1.31-1.95,1.33,1.33,0,0,0-1.38-1.42c-1.13.07-2.18,1.81-2.43,2.79,0,.08-.2,1.44-.18,1.44h0l-.53.9c-.34.6-.71,1.29-1.08,2.07a23.88,23.88,0,0,0-1,2.56,16.88,16.88,0,0,0-.76,3v0c0-.33-.23-1.24-.25-1.31-.3-1-1.44-2.64-2.57-2.65a1.33,1.33,0,0,0-1.3,1.5,2.79,2.79,0,0,0,1.42,1.87,9.1,9.1,0,0,0,2.69.71,21.6,21.6,0,0,0-.21,3.14c0,.62,0,1.23,0,1.85-.06-.28-.11-.53-.12-.56-.3-1-1.44-2.65-2.57-2.66a1.33,1.33,0,0,0-1.3,1.5,2.77,2.77,0,0,0,1.42,1.87,8.65,8.65,0,0,0,2.61.7l0,.71c.06,1.14.13,2.28.16,3.39,0,.4,0,.78,0,1.17,0-.25-.09-.46-.1-.49-.3-1-1.44-2.65-2.57-2.66a1.34,1.34,0,0,0-1.3,1.5,2.78,2.78,0,0,0,1.41,1.88,8.61,8.61,0,0,0,2.54.68c0,.4,0,.8-.06,1.18s0,.52-.08.78-.07.52-.11.77c-.09.49-.17,1-.27,1.47-.06.33-.13.64-.2.95,0-.39,0-1.15,0-1.22-.15-1-1-2.83-2.14-3a1.33,1.33,0,0,0-1.51,1.28,2.78,2.78,0,0,0,1.11,2.07,9,9,0,0,0,2.53,1.1c-.11.52-.23,1-.34,1.51-.4,1.65-.8,3-1.09,4s-.48,1.48-.48,1.48a.4.4,0,0,0,.75.26h0s.19-.55.46-1.52.64-2.35,1-4c.12-.53.23-1.1.34-1.69a9.22,9.22,0,0,0,2.76-.26,2.81,2.81,0,0,0,1.7-1.62,1.34,1.34,0,0,0-1-1.69c-1.12-.17-2.52,1.31-3,2.21,0,.05-.25.66-.39,1.05,0-.24.1-.48.14-.72.09-.49.16-1,.24-1.51l.09-.77c0-.26,0-.53.07-.8,0-.63,0-1.27,0-1.91a8.69,8.69,0,0,0,2.68.15,2.83,2.83,0,0,0,1.93-1.35,1.34,1.34,0,0,0-.78-1.83c-1.07-.34-2.68.91-3.26,1.73,0,.05-.39.69-.58,1.05q0-.59,0-1.17c0-1.12-.14-2.26-.23-3.39,0-.35,0-.7-.07-1.05a9.3,9.3,0,0,0,2.78.17,2.79,2.79,0,0,0,1.92-1.35,1.34,1.34,0,0,0-.77-1.83c-1.08-.34-2.69.91-3.27,1.73,0,.06-.54,1-.66,1.22-.05-.76-.1-1.53-.11-2.28a23.32,23.32,0,0,1,.13-3,9.74,9.74,0,0,0,2.79.16,2.81,2.81,0,0,0,1.93-1.34,1.34,1.34,0,0,0-.78-1.83c-1.07-.34-2.68.9-3.26,1.73,0,.06-.59,1.05-.67,1.23a1,1,0,0,1,0-.17,16.67,16.67,0,0,1,.68-3c.17-.54.36-1,.55-1.53a9.33,9.33,0,0,0,2.7.45,2.83,2.83,0,0,0,2.06-1.13,1.34,1.34,0,0,0-.57-1.9c-1-.46-2.77.61-3.44,1.36l-.59.83c.09-.21.18-.44.28-.65C113,325.93,113.34,325.24,113.67,324.62Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.29,356.69A45.3,45.3,0,0,0,27,362.52H453.21a11.54,11.54,0,0,0,.34-4.11c-.26-4.72-3.73-5-7.8-8.29H40C35.39,351.64,30.91,353.26,29.29,356.69Z",
    style: {
      fill: "#4819F2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.29,356.69A45.3,45.3,0,0,0,27,362.52H453.21a11.54,11.54,0,0,0,.34-4.11c-.26-4.72-3.73-5-7.8-8.29H40C35.39,351.64,30.91,353.26,29.29,356.69Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-1--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412,119.65s-1.43-20-30.77-20.75-21.46,20-29.33,25-10-2.87-17.89,2.14-4.29,15-10.73,16.46-15-6.44-22.89-1.43-7.87,9.3-11.45,9.3-10.73-2.86-15,0-9.3,6.44-9.3,6.44h181s2.14-6.44-5.73-10.73-11.45-.72-14.31-4.3S433.47,129,412,119.65Z",
    style: {
      fill: "#4819F2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412,119.65s-1.43-20-30.77-20.75-21.46,20-29.33,25-10-2.87-17.89,2.14-4.29,15-10.73,16.46-15-6.44-22.89-1.43-7.87,9.3-11.45,9.3-10.73-2.86-15,0-9.3,6.44-9.3,6.44h181s2.14-6.44-5.73-10.73-11.45-.72-14.31-4.3S433.47,129,412,119.65Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.08,86.8s-1-13.83-21.24-14.33S213,86.31,207.57,89.77s-6.91-2-12.35,1.48-3,10.38-7.41,11.37-10.38-4.45-15.81-1-5.44,6.42-7.91,6.42-7.41-2-10.38,0-6.42,4.45-6.42,4.45h125s1.48-4.45-3.95-7.41-7.91-.5-9.89-3S263.91,93.23,249.08,86.8Z",
    style: {
      fill: "#4819F2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.08,86.8s-1-13.83-21.24-14.33S213,86.31,207.57,89.77s-6.91-2-12.35,1.48-3,10.38-7.41,11.37-10.38-4.45-15.81-1-5.44,6.42-7.91,6.42-7.41-2-10.38,0-6.42,4.45-6.42,4.45h125s1.48-4.45-3.95-7.41-7.91-.5-9.89-3S263.91,93.23,249.08,86.8Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.05,123.76s-.53-7.41-11.39-7.68-8,7.42-10.86,9.27-3.71-1.06-6.62.8-1.59,5.56-4,6.09-5.56-2.38-8.47-.53-2.92,3.45-4.24,3.45-4-1.06-5.56,0-3.45,2.38-3.45,2.38h67s.8-2.38-2.12-4-4.24-.27-5.29-1.59S154,127.21,146.05,123.76Z",
    style: {
      fill: "#4819F2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.05,123.76s-.53-7.41-11.39-7.68-8,7.42-10.86,9.27-3.71-1.06-6.62.8-1.59,5.56-4,6.09-5.56-2.38-8.47-.53-2.92,3.45-4.24,3.45-4-1.06-5.56,0-3.45,2.38-3.45,2.38h67s.8-2.38-2.12-4-4.24-.27-5.29-1.59S154,127.21,146.05,123.76Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-1--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M366,401.51c0,2.52-18.14,4.55-40.52,4.55S285,404,285,401.51,303.09,397,325.47,397,366,399,366,401.51Z",
    style: {
      fill: "#4819F2",
      opacity: 0.33
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.79,399.45c0,2.51-18.14,4.55-40.52,4.55s-40.52-2-40.52-4.55,18.14-4.55,40.52-4.55S445.79,396.94,445.79,399.45Z",
    style: {
      fill: "#4819F2",
      opacity: 0.33
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 208.12,
    cy: 396.55,
    rx: 40.52,
    ry: 4.55,
    style: {
      fill: "#4819F2",
      opacity: 0.33
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 117.36,
    cy: 400.27,
    rx: 40.52,
    ry: 4.55,
    style: {
      fill: "#4819F2",
      opacity: 0.33
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-1--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.84,351.45s5.8-2.65,7.12-4.44,2.39-1.13,1.78,1-3.67,4-3.67,4",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.86,375.17s2,7.22,3.16,10,1.89,4.09-.47,5.92-8.51,4.49-10.24,4.56-4-3.67-2.92-3.71a10.06,10.06,0,0,1,2.8.59s3.43-1.18,4.41-2.6-2.91-12.74-2.91-12.74",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.09,368.28s3.2,2,.68,8.66-8.28,10.73-8.21,12.47a20.27,20.27,0,0,0,2.34,6.85c.74,1,4.22,1.23,3.91,2.28s-.29,1.41-2.37,1.48a6.26,6.26,0,0,1-5.3-2.22c-1.45-1.69-3.77-7.85-4.2-9.92s3.23-6.37,3.83-8.83-1.67-7.57,1-10.8S392.63,366.6,394.09,368.28Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.88,347.39a18.94,18.94,0,0,0-6.59.25c-2.75.8-10,2.12-22.48,2.6s-17.57-5.24-26.88-3.49-13.38,13.36-12.78,19.93,4.18,9.57,2.87,11.7-5.28-1.88-5,5.06,3.47,18.27,5.54,17.85.83-14.62.78-16,9.67-1.41,12.31-5,4.83-9.91,4.83-9.91,2.79.24,8.14,3.85,17.95,6.27,26.94,5.23,11.2-7,11.2-7l3.05-1.85Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449,350s-6.43-3.74-8.12-2.63.82,21.5,1.92,23.2c.89,1.36,3.25,1.41,16.9,0a7.55,7.55,0,0,1,2.8.79,6.4,6.4,0,0,0,3.64.48l3.78-.58s3.38-2.56,1.91-4.59-4.58-2.83-5.38-5.57-4.89-8.62-4.89-8.62A32.31,32.31,0,0,0,449,350Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.07,354a18.77,18.77,0,0,0,5.49-1.08c2.3-1,3.7-2.48,3.78-.44s-2.69,5.93-4.4,6.87a5.91,5.91,0,0,1-4.08.16",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.17,371.71s1,8.3,2.57,12.75,8.24,15.67,10.36,16.63,6.34,2.19,6.95.08.26-2.44-1.85-3.06l-2.11-.61s-6.3-10.53-6.48-15,1.63-11.87,1.63-11.87",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.7,354.34c-6.77,0-5.6,2.35-7.78,1.92s3.05-3.48-1.31-3.92-10.12-1.21-10.12-1.21l-2.93-1.84s-4.93.09-13.78.92-16.36,1-23.26,1.76a46.7,46.7,0,0,1-12.76-.31s1.5-11.94-5.9-13.68-8.7,14.36-8.7,14.36-3,5.66-3.48,10,4.35,10,3.92,12.62-3.48,5.22-.87,5.22,6.09,1.74,8.7-4.35,3.57-9,7.66-7.56,19.32,6.25,25,5.82,4.36,7.83,7.84,8.26,3.91-7.83,3.91-9.13,6.09-3.92,5.66-6.1-5.54-7.39-4.79-10.87,6.81-5.24,6.81-5.24.36,11.13,3.31,13.19,4.68,5.54,8.16,2.05,3.15-6.3,6.53-6.52S471.48,354.32,464.7,354.34Zm-83-6.38c-1.63.49-1.61.36-2-1.47s1.15-3.44,3.76-3.44,5.9,4.74,5.9,4.74C387.31,345.67,383.38,347.47,381.74,348Z",
    style: {
      fill: "#4819F2",
      opacity: 0.6000000000000001,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.82,354.77s2.65-3.22-.07-10.76,3.7-12.3,9.57-13.22,11.37,6.52,12.59,11.33-.66,10.1-4.15,9.54-4.07-6.45-7.59-7.7-6.15,2.66-5,4.36",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.76,351.66s1.5-11.94-5.9-13.68c-5.8-1.36-7.85,8.24-8.47,12.45l1.74-2.11a1.81,1.81,0,0,1-.23-1.23,2.13,2.13,0,0,1-.12-.6c0-1,2.22-2.95,4.84-2.95,1.28,0,3.25,2.6,3.25,2.6-.31-.31.9,1.12.52,1C389.63,349.11,390.68,351.32,392.76,351.66Z",
    style: {
      fill: "#4819F2",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.57,368.75a18.77,18.77,0,0,1,3.62,2.38",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.44,361.87c0,.67-.19,1.22-.48,1.24s-.54-.53-.57-1.2.19-1.22.48-1.23S466.41,361.2,466.44,361.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.19,367.81c0,.67-.18,1.22-.47,1.23s-.54-.52-.57-1.19.19-1.22.48-1.23S472.17,367.14,472.19,367.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 459.7,
    y1: 370.6,
    x2: 456.55,
    y2: 369.28,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.6,346.85s.87-4.66,2.33-5.53",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.68,342.19s1.16-2.33,3.2-2.33",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.17,341.9a4,4,0,0,1,5,1.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389,343.65s2.91,2,2.91,4.07",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.83,369.28a6.3,6.3,0,0,0,4.37,0c2.33-.87,3.49-1.16,3.49-1.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 408.48,
    y1: 366.95,
    x2: 406.73,
    y2: 367.83,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.78,371s3.2.58,5-.58",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.39,375.4s4.37.87,6.41.29",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.34,350.64s-3.5,1.45-4.37,2.62l-.88,1.17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.51,352.09s-2.33,2.63-2.62,3.79",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 414.01,
    y1: 353.55,
    x2: 411.98,
    y2: 355.88,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441,355.45a4.86,4.86,0,0,0,4.52,3.35",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.86,360s2.91,1.17,4.66.58",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.17,352.09s-3.49,2-2.33,5.54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.51,357.05s.88,5.82,6.41,6.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.73,279.61a85.2,85.2,0,0,0-1.39,9c0,2.09,11.45,41.65,11.45,47.55s4.86,57.27,4.86,57.27l-8,1.73s-6.6-24.64-9.72-33.66-4.51-24.64-4.51-24.64l-7.29-26s-5.9-11.8-8.68-16.32-5.2-8-4.86-11.8,4.17-6.24,4.17-6.24Z",
    style: {
      fill: "#4819F2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.73,279.61a85.2,85.2,0,0,0-1.39,9c0,2.09,11.45,41.65,11.45,47.55s4.86,57.27,4.86,57.27l-8,1.73s-6.6-24.64-9.72-33.66-4.51-24.64-4.51-24.64l-7.29-26s-5.9-11.8-8.68-16.32-5.2-8-4.86-11.8,4.17-6.24,4.17-6.24Z",
    style: {
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.06,296s-3.19,1.77-2.48,3.9,4.6,5,6.73,5.66,9.91-3.54,10.62-6.37-1.42-8.14-2.83-8.85l-1.42-.71Z",
    style: {
      fill: "#4819F2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 375.45,
    y1: 301.97,
    x2: 440.88,
    y2: 347.39,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.63,347.43s-.15,4.12-.15,9.43S441.57,371,441.57,371l1.23-.45S441,357.92,441,355.45s.23-8.21.23-8.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442,347.58s-5.9-5.68-7.43-5.68-2,1.09-1.31,2,5.39,3.57,5.39,3.57S440.45,349.76,442,347.58Z",
    style: {
      fill: "#4819F2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442,347.58s-5.9-5.68-7.43-5.68-2,1.09-1.31,2,5.39,3.57,5.39,3.57S440.45,349.76,442,347.58Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.66,282.85s3.54,3.9,4.25,5a18.87,18.87,0,0,1,1.77,6.37c0,1.42-6,4.61-8.14,4.25s-3.55-3.18-3.9-4.25-1.77-4.6-1.77-4.6Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.71,277.87a34.46,34.46,0,0,0,.7,12.85c1.73,6.24,4.51,11.8,4.51,12.84s-2.08,31.23-2.43,32.28S292.54,390,292.89,391s5.55,3.12,5.55,3.12,34.71-48.24,36.44-50.67,8-45.81,9-48.24S346,277.18,346,277.18,322.39,276.49,313.71,277.87Z",
    style: {
      fill: "#4819F2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.71,277.87a34.46,34.46,0,0,0,.7,12.85c1.73,6.24,4.51,11.8,4.51,12.84s-2.08,31.23-2.43,32.28S292.54,390,292.89,391s5.55,3.12,5.55,3.12,34.71-48.24,36.44-50.67,8-45.81,9-48.24S346,277.18,346,277.18,322.39,276.49,313.71,277.87Z",
    style: {
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 345.26,
    y1: 290.04,
    x2: 339.44,
    y2: 322.67,
    style: {
      fill: "none",
      stroke: "#4819F2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px",
      opacity: 0.59
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.48,285.67a25.91,25.91,0,0,1-3.2,4.66,6.34,6.34,0,0,1-2.91,1.75",
    style: {
      fill: "none",
      stroke: "#4819F2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px",
      opacity: 0.59
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.2,285.09s.29,8.45.58,11.94a96,96,0,0,1-.58,17.48c-.87,8.45-.87,12.53-.87,12.53",
    style: {
      fill: "none",
      stroke: "#4819F2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px",
      opacity: 0.59
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.65,393.45s12.84,2.08,12.84,3.47-19.78,8-20.82,6.25,0-8,0-8Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.89,391s-4.86,5.55-4.51,6.94,5.9,4.17,8.67,4.51,9,.35,10.76-.69-3.81-2.43-5.2-3.82-4.17-3.82-4.17-3.82Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.81,401.78s-7.41-.16-10.62-1-7.86-4.08-7.86-4.08l-.5-.17a2.47,2.47,0,0,0-.45,1.46c.34,1.39,5.9,4.17,8.67,4.51S306.08,402.82,307.81,401.78Z",
    style: {
      fill: "#4819F2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.32,400.16c-3.49,1.46-7.86.88-8.73.88l-.36,0a4.81,4.81,0,0,0,.44,2.08c1,1.73,20.82-4.86,20.82-6.25,0-.2-.28-.42-.75-.65l-.64.11S366.82,398.71,363.32,400.16Z",
    style: {
      fill: "#4819F2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.71,207.67l2,.88a1.93,1.93,0,0,1,.75,3l-9,11.43a1.83,1.83,0,0,1-2.64.24l-1.52-1.34a1.81,1.81,0,0,1-.25-2.45l8.27-11.1A2,2,0,0,1,389.71,207.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.14,227.25s2.48-1.77,2.83-2.83-.35-2.12,1.42-4.6a13.84,13.84,0,0,1,5-3.9s1.41-2.12,2.48-1.77,1.41,1.06.7,2.48a27.29,27.29,0,0,1-2.83,3.9s7.51-3.95,9.16-3.21c.92.43-.68,2.7-.68,2.7s-2.1,5.46-3.17,6.53-12.75,6.37-12.75,6.37Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.18,288.87V291l2.48,1.06s-4.25,6-2.12,6.37,5.31-4.25,5.66-5.31a11.09,11.09,0,0,0,0-3.54",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 361.64,
    y1: 294.18,
    x2: 367.66,
    y2: 292.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.66,249.92s7.44,16.64,8.86,19.12,9.2,11.69,9.56,13.1-6,6-7.79,7.44L359.52,291s-5.32-4.25-5.32-6-5.66-14.88-6-15.94-3.54-12-3.54-12S345,247.44,350.66,249.92Z",
    style: {
      fill: "#4819F2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.66,249.92s7.44,16.64,8.86,19.12,9.2,11.69,9.56,13.1-6,6-7.79,7.44L359.52,291s-5.32-4.25-5.32-6-5.66-14.88-6-15.94-3.54-12-3.54-12S345,247.44,350.66,249.92Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.62,203.17l6,6.38s2.13,5,1.07,5.31l-1.07.35s8.86,42.14,10.63,50.64,2.83,13.46,2.12,15.23-4.25,1.77-4.25,1.77l-7.43-2.12-10.27-75.08S334.37,200.7,338.62,203.17Z",
    style: {
      fill: "#4819F2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.62,203.17l6,6.38s2.13,5,1.07,5.31l-1.07.35s8.86,42.14,10.63,50.64,2.83,13.46,2.12,15.23-4.25,1.77-4.25,1.77l-7.43-2.12-10.27-75.08S334.37,200.7,338.62,203.17Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 364.2,
    y1: 276.64,
    x2: 358.96,
    y2: 280.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,184.62c.17-1.35.32-2.73.42-4.12.37-5.06-.47-10.48-5-13.46s-13.27-3.91-17.79-.41c-3.89,3-5.82,8.06-6,12.87a11.07,11.07,0,0,0,1.34,6.06c.87,1.84,2.72,3.93,2.17,6.14-.64,2.55-5.73,8.48-5.73,8.48L335.5,208a22,22,0,0,1,5.73-4.88,12.59,12.59,0,0,1,7.06-1.81c2.86,1.62,6.18,2.19,7.14.87.84-1.16,2.22-5.19,3.35-10.45a2.55,2.55,0,0,0,2.7-1.1C362.21,189.27,360.46,185.56,360,184.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-1--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.42,173.13s-8.35.2-8.54,1.19a16.83,16.83,0,0,0-.2,2.59s-2.58-3.78,1.39-4.17A25,25,0,0,1,359.42,173.13Z",
    style: {
      fill: "#4819F2",
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.46,198.85l3.73,3.48,6.56-13.11-6-.14a4.24,4.24,0,0,1,.3,2.62C334.64,193.49,332,197,330.46,198.85Z",
    style: {
      fill: "#4819F2",
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M360,184.62c.17-1.35.32-2.73.42-4.12.37-5.06-.47-10.48-5-13.46s-13.27-3.91-17.79-.41c-3.89,3-5.82,8.06-6,12.87a11.07,11.07,0,0,0,1.34,6.06c.87,1.84,2.72,3.93,2.17,6.14-.64,2.55-5.73,8.48-5.73,8.48L335.5,208a22,22,0,0,1,5.73-4.88,12.59,12.59,0,0,1,7.06-1.81c2.86,1.62,6.18,2.19,7.14.87.84-1.16,2.22-5.19,3.35-10.45a2.55,2.55,0,0,0,2.7-1.1C362.21,189.27,360.46,185.56,360,184.62Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.66,183.27s3.28.44,3.72-1.09,1.31-2.18,3.27-3.06-.43-2.62-.87-4.8,6.55-2.19,10.7-1.1,8.53,1.1,7.43-4.59-5.46-4.58-7.64-4.58,2.18-4.15-2.41-5.68-5.46,1.09-5.9,2.62-2.62,1.53-4.58,1.53-3.94-2.41-11.37.43-8.74,12.68-7,18.58,2.73,8.77,6.07,10.17,8.57-4.93,8.57-6.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.76,173.81s.29-1.17-2.91,1.45-4.37,5.25-9,5.54",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.74,184.29s3.49,1.46,5.53,0",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.85,181.5l-1,6a.94.94,0,0,0,.7,1.08l.34.08,1-6a1,1,0,0,0-.7-1.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.85,181.5s-16.07-.29-17,0a14.14,14.14,0,0,0-1.71,2.61c-.28.84.51.7,1,.24s1.29-2.18,1.71-2.27,15.81.88,15.81.88l.37-1.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.19,184.24s-.44-5.25-3.93-1.75-.88,7.43.87,7.86a2.41,2.41,0,0,0,2.62-1.31",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.55,196.16s-3.71-.65-3.71-2",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.93,184.58s2.36.17,2.62,1.53",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.8,179.56s2.19-2.19,3.5-.22",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.13,190.35s.38,4.43,2.13,7.05",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.7,197.06l11.09,12.09s3.81,27.08,7.28,47.55,3.47,27.77,3.47,27.77a126.35,126.35,0,0,1-21.51,0,138.58,138.58,0,0,1-21.18-3.82s3.13-47.55,5.56-60.74c2.16-11.74,12.31-21,14.5-22.9A.57.57,0,0,1,329.7,197.06Z",
    style: {
      fill: "#4819F2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.7,197.06l11.09,12.09s3.81,27.08,7.28,47.55,3.47,27.77,3.47,27.77a126.35,126.35,0,0,1-21.51,0,138.58,138.58,0,0,1-21.18-3.82s3.13-47.55,5.56-60.74c2.16-11.74,12.31-21,14.5-22.9A.57.57,0,0,1,329.7,197.06Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.17,200.48s9,13.19,10.06,14.23,5.56-5.56,5.56-5.56-9.72-11.8-11.46-12.49S325.17,200.48,325.17,200.48Z",
    style: {
      fill: "#4819F2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.57,220.14c2.29,3.22,7.53,20.57,7.53,20.57S366.62,227,368.39,227c2.13-.71,3.9,2.84,5.67,7.79s.71,5.67.71,5.67l-11,2.41c-12,7.66-30.93,20.07-31.88,19.12-1.41-1.42-6.72-14.87-9.56-21.25s-3.18-13.81-1.06-19.12a37.73,37.73,0,0,1,1.87-4s3.09-3.4,4.86-2.69",
    style: {
      fill: "#4819F2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.57,220.14c2.29,3.22,7.53,20.57,7.53,20.57S366.62,227,368.39,227c2.13-.71,3.9,2.84,5.67,7.79s.71,5.67.71,5.67l-11,2.41c-12,7.66-30.93,20.07-31.88,19.12-1.41-1.42-6.72-14.87-9.56-21.25s-3.18-13.81-1.06-19.12a37.73,37.73,0,0,1,1.87-4s3.09-3.4,4.86-2.69",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370.61,
    cy: 238.38,
    r: 1.07,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 358.71,
    y1: 233.49,
    x2: 362.25,
    y2: 240.73,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.1,240.71s-3.61,2.72-4.11,5.24",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.66,241.74s-3.37,2.7-3.2,6.07",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 343.22,
    y1: 227.41,
    x2: 338.56,
    y2: 227.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.39,
    y1: 233.24,
    x2: 339.73,
    y2: 233.24,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.6,276.35a109.88,109.88,0,0,0,16.89,3.21l8.74.87",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.73,
    y1: 280.43,
    x2: 347.73,
    y2: 279.61,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 345.55,
    y1: 257.12,
    x2: 347.88,
    y2: 273.73,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.29,216.05s1.75-7,4.08-9.32",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 330.41,
    y1: 208.76,
    x2: 327.78,
    y2: 211.68,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.66,
    y: 171.71,
    width: 48.19,
    height: 24.32,
    rx: 4.05,
    style: {
      fill: "#4819F2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "391.66 189.67 391.66 202.73 398.95 194.35",
    style: {
      fill: "#4819F2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.46,184.32a2.5,2.5,0,1,0-2.49,2.49A2.5,2.5,0,0,0,408.46,184.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.16,184.32a2.5,2.5,0,1,0-2.49,2.49A2.5,2.5,0,0,0,419.16,184.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.86,184.32a2.5,2.5,0,1,0-2.5,2.49A2.5,2.5,0,0,0,429.86,184.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 316.42,
    y1: 237.61,
    x2: 322.33,
    y2: 240.71,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.26,243.72s5.53.29,7.57-1.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.78,337.53s-11.07-1.46-8.15.29a33.86,33.86,0,0,0,7.28,2.91h-6.7",
    style: {
      fill: "none",
      stroke: "#4819F2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px",
      opacity: 0.59
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-1--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.63,302.77s-3,37.32-4.21,40.14-21,44.66-21,44.66l-3.8-2.13L209.84,334l-2.69-57.52Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.66,268.47s5.64,30.33,6.82,39.26.29,83.66.29,83.66l-4.35.63-12.87-82.88S212.89,291,209,286.49c-4.51-5.22-6.78-11.45-4.16-16.61C206.55,266.42,230.66,268.47,230.66,268.47Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.4,377.06c6-12.59,15.23-32.25,16-34.15,1.18-2.82,4.21-40.14,4.21-40.14l-17.48-26.31L209.84,334l-11.28,40.83Z",
    style: {
      fill: "#4819F2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.88,380.28c.22-21,.49-65.78-.4-72.55-1.18-8.93-6.82-39.26-6.82-39.26s-24.11-2.05-25.86,1.41c-2.62,5.16-.35,11.39,4.16,16.61,3.93,4.55,11.59,22.65,11.59,22.65l11.27,71.52A19.59,19.59,0,0,0,237.88,380.28Z",
    style: {
      fill: "#4819F2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.44,271.77s-2.1,2.1-.7,3.27,7-.47,5.37.7-7.94,5.14-4.44,4.68,7.72-.94,6.08.7-2.34,1.63-1.17,4.2,2.81,7.95,2.81,7.95",
    style: {
      fill: "#4819F2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 225.09,
    y1: 295.37,
    x2: 227.19,
    y2: 301.22,
    style: {
      fill: "#4819F2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.31,319.21s-.93,15.43-1.64,17.77-4.2-.47-2.8,1.4,3,2.57,2.34,2.8-2.81-.23-2.81.7-2.34,8.42-2.34,8.42",
    style: {
      fill: "#4819F2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.77,391.39s11.76,3,11.38,4.17-13.58,3.23-14.5,3.11-1.23-6.65-1.23-6.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-1--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.75,398.77c.92.12,14.12-2,14.5-3.11.08-.24-.39-.57-1.19-.94L234,396.61C234.14,397.78,234.4,398.73,234.75,398.77Z",
    style: {
      fill: "#4819F2",
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M237.77,391.39s11.76,3,11.38,4.17-13.58,3.23-14.5,3.11-1.23-6.65-1.23-6.65Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.43,387.57a12.57,12.57,0,0,0,2.09,2.49c.93.7,4.43,2.1,4.43,3s-7,1.4-8.4,1.17-3-3-4.43-4,2.51-4.85,2.51-4.85A40,40,0,0,0,199.43,387.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-1--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206,393.09c0-.23-.21-.49-.55-.76-2.23.22-5.22.41-6.48,0s-4-2.56-5.64-4c-.47.81-.68,1.56-.16,1.91,1.4.93,3,3.73,4.43,4S206,394,206,393.09Z",
    style: {
      fill: "#4819F2",
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M199.43,387.57a12.57,12.57,0,0,0,2.09,2.49c.93.7,4.43,2.1,4.43,3s-7,1.4-8.4,1.17-3-3-4.43-4,2.51-4.85,2.51-4.85A40,40,0,0,0,199.43,387.57Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.29,217.08s3.5-1.17,4-2.34a19.81,19.81,0,0,0,.7-4S265.52,215.44,265.29,217.08Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.17,209.92s-3.76,6.12-3.76,6.82-17.17,15.76-17.17,15.76-4,2.35-4.7,3.76-.47,10.11.47,10.34,22.81-26.57,24-27,5.17-1.88,5.17-1.88l3.77-4.7Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.37,204.15l1.92.84a1.82,1.82,0,0,1,.7,2.8l-8.46,10.81a1.73,1.73,0,0,1-2.5.23l-1.44-1.27a1.73,1.73,0,0,1-.24-2.32l7.83-10.5A1.83,1.83,0,0,1,269.37,204.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.28,208s3.77,4,3.53,4.94-1.41,1.65-2.12.94-3.29-2.82-3.52-4A1.58,1.58,0,0,1,260.28,208Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,223.09c-1.65-4.23-4.23-18.81-4.23-18.81-1.89-3.29-6.59-8.23-8.7-8.93s-.47,0-2.59,1.41-7.05,9.87-10.58,21.63c-1.14,3.8-2.51,9.64-3.83,15.86a94.47,94.47,0,0,0-3.79,19.27c-.95,5.27-1.57,9.14-1.57,9.83a2.23,2.23,0,0,0,1.3,1.79c0,7.61.1,11.07.1,11.07s5.61-4.44,8.41-5.61A17,17,0,0,1,227,272.7c4.27,2.85,7.71,5.38,8.18,4.21s-.6-5.24-1.4-8.65c-.94-4-2.58-15.66-2.58-15.66,0-2.82,3-17,4.44-19.16A11.48,11.48,0,0,0,237,223.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-1--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.41,247.32l-8.1,14.84s7.16-22.13,7.83-30.76,8.9-22.67,11.06-26.17,2.7-4.59,2.7-4.59l2.3-1.06c-1.88-2.06-3.92-3.83-5.12-4.23-2.12-.71-.47,0-2.59,1.41s-7.05,9.87-10.58,21.63c-1.14,3.8-2.51,9.64-3.83,15.86a94.47,94.47,0,0,0-3.79,19.27c-.95,5.27-1.57,9.14-1.57,9.83a2.23,2.23,0,0,0,1.3,1.79c0,7.61.1,11.07.1,11.07a68.87,68.87,0,0,1,7.3-5.07,13.26,13.26,0,0,0-.52-2,8.94,8.94,0,0,1,.81-7,69.62,69.62,0,0,1,7.82-8.36c2.43-2.16-7.28-1.62-5.12-3s11.6-5.94,13.22-7.56S213.41,247.32,213.41,247.32Z",
    style: {
      fill: "#4819F2",
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M237,223.09c-1.65-4.23-4.23-18.81-4.23-18.81-1.89-3.29-6.59-8.23-8.7-8.93s-.47,0-2.59,1.41-7.05,9.87-10.58,21.63c-1.14,3.8-2.51,9.64-3.83,15.86a94.47,94.47,0,0,0-3.79,19.27c-.95,5.27-1.57,9.14-1.57,9.83a2.23,2.23,0,0,0,1.3,1.79c0,7.61.1,11.07.1,11.07s5.61-4.44,8.41-5.61A17,17,0,0,1,227,272.7c4.27,2.85,7.71,5.38,8.18,4.21s-.6-5.24-1.4-8.65c-.94-4-2.58-15.66-2.58-15.66,0-2.82,3-17,4.44-19.16A11.48,11.48,0,0,0,237,223.09Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.76,215.44s0,2.57.94,3,3.27-.23,2.8,1.64-.7,3.27.24,4a6.17,6.17,0,0,0,2.33.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.26,232.74s7.1.49,9.08-.33-3.8-7.93-3.8-7.93Z",
    style: {
      fill: "#4819F2",
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M229,182.69c1.42,5.08-1.59,12-4.46,13.47-.89.44,2.09,4.63,4.38,7.41l2,3.46.94,4.67,1.4-.23s-1.22-5-.49-7.19S234,201,234,201a12,12,0,0,1,5-5C239.37,191.65,228.39,180.59,229,182.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-5--inject-1--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "236 198.18 229.2 199.58 226.9 200.64 224.05 197.88 230.16 191.93 236 198.18",
    style: {
      fill: "#4819F2",
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M229,182.69c1.42,5.08-1.59,12-4.46,13.47-.89.44,2.09,4.63,4.38,7.41l2,3.46.94,4.67,1.4-.23s-1.22-5-.49-7.19S234,201,234,201a12,12,0,0,1,5-5C239.37,191.65,228.39,180.59,229,182.69Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.55,167.11c3.32,1.67,6.94,4.45,6.94,8.48,0,7-2.86,9.83-2.86,11.6s2.35,4.11,1.47,5-2.94.58-2.94.58a64.33,64.33,0,0,1-4.7,7.36c-1.77,2.06-5-.89-8.53-3.53s-5.3-5-5.3-10-2.47-8.68-.3-13.54A12,12,0,0,1,244.55,167.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-6--inject-1--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.55,167.11a12,12,0,0,0-16.22,5.95c-2.17,4.86.3,8.55.3,13.54s1.77,7.35,5.3,10l2.07,1.58c-3-1.92-2.09-8.06-2.09-10s3.24-2.43,5.94-3.51c2.06-.83,8.36-3.53,11.22-4.77a21.92,21.92,0,0,0,.42-4.36C251.49,171.56,247.87,168.78,244.55,167.11Z",
    style: {
      fill: "#4819F2",
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M244.55,167.11c3.32,1.67,6.94,4.45,6.94,8.48,0,7-2.86,9.83-2.86,11.6s2.35,4.11,1.47,5-2.94.58-2.94.58a64.33,64.33,0,0,1-4.7,7.36c-1.77,2.06-5-.89-8.53-3.53s-5.3-5-5.3-10-2.47-8.68-.3-13.54A12,12,0,0,1,244.55,167.11Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.55,195.57s-2.1-.46-2.57-1.63",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.59,186.46l-.7,1.17a2.36,2.36,0,0,1-2.1-.7",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.55,184.36s2.34-2.11,3.74-1.17",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "168.76 315.71 190.26 291.63 194 318.05",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.98 318.28 163.38 315.24 151 353.34 204.52 358.71 197.98 318.28",
    style: {
      fill: "#4819F2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.03,
    y1: 289.76,
    x2: 177.41,
    y2: 318.28,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 191.67,
    y1: 292.57,
    x2: 197.04,
    y2: 320.62,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.48 321.32 170.86 317.81 160.11 359.65 204.87 363.63 201.48 321.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.08,183c-1.4-7.94-8.88-16.12-8.88-16.12l0,0a13.59,13.59,0,0,0-5.81-3.72c-6.08-2.11-14.49-2.34-21.27,3.27s-8,17.06-10.29,23.14-3.74,10.05-3.27,12.15,7-1.4,8.18-1.17.24,1.64,2.34,1.64,4.91-3.74,6.08-3.74,4.82.41,5.8-1.78-4.4-9.44-2.53-12.71c0,0,1.17.47,9.35-1.87a53.37,53.37,0,0,0,10.62-4c-.54,5.32-2.74,7.65-2.74,9.2,0,1.76,2.35,4.11,1.47,5s-2.94.58-2.94.58a64.33,64.33,0,0,1-4.7,7.36c-1.42,1.64-3.77.09-6.46-1.95a9.18,9.18,0,0,0-2,2.79s-.27.63-.71,1.83a5.18,5.18,0,0,0,2.78,2.12c2.57.47,4-.93,5.14-1.63s3.51.46,5.85,0,1.87-2.57,2.8-3.74,2.57,1.87,4.44,0S262.48,190.9,261.08,183Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.32,167.92c1.19,1.68,5.26,5.27,3.83,7a11.68,11.68,0,0,1-3.59,2.63",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.12,172.71s-9.58,6.71-14.61,7.42-11-1.19-11-1.19",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.25,166a28.85,28.85,0,0,1-8.62,8.38,19.82,19.82,0,0,1-10.3,3.11",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.27,185.29s-1.64-5.61-3.27-4.91-1.87,3.51-1.17,5.85,2.33,2.1,3.27,1.4",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.27,185.29s-1.64-5.61-3.27-4.91-1.87,3.51-1.17,5.85,2.33,2.1,3.27,1.4",
    style: {
      fill: "#fff",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-7--inject-1--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.44,
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.33,185.29s-1.63-5.61-3.27-4.91-1.87,3.51-1.17,5.85,2.34,2.1,3.27,1.4",
    style: {
      fill: "#4819F2"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M227.35,206.18c-2.47-2.09-6.33-1.21-8,3.18-2.8,7.16-5.6,14.34-8.47,21.51-2.8,7-14,41.37-15,43.94s-3,9.11-3,9.11-4.67,3.51-4.67,4.21,1.17,3.27,2.1,3.5a6.5,6.5,0,0,0,4-1.16c.93-.71,1.4-2.11,2.57-5.61,0,0,7-18.7,11.68-24.54s8.42-21,9.35-22.68a144.17,144.17,0,0,0,8.42-15.42c1.56-3.45,3.67-7.59,3.24-11.51A7,7,0,0,0,227.35,206.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-8--inject-1--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.36,207.37a5.06,5.06,0,0,0-1-1.19c-2.47-2.09-6.33-1.21-8,3.18-2.8,7.16-5.6,14.34-8.47,21.51-2.8,7-14,41.37-15,43.94s-3,9.11-3,9.11-4.67,3.51-4.67,4.21a6.19,6.19,0,0,0,.85,2.18,3.52,3.52,0,0,0,1.19-1.71c.17-1.16,3.78-3.5,4.59-5.39s14.57-34.27,15.11-37.51,8.36-27.52,10.79-31.84,7.83-5.67,7.83-5.67Z",
    style: {
      fill: "#4819F2",
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M227.35,206.18c-2.47-2.09-6.33-1.21-8,3.18-2.8,7.16-5.6,14.34-8.47,21.51-2.8,7-14,41.37-15,43.94s-3,9.11-3,9.11-4.67,3.51-4.67,4.21,1.17,3.27,2.1,3.5a6.5,6.5,0,0,0,4-1.16c.93-.71,1.4-2.11,2.57-5.61,0,0,7-18.7,11.68-24.54s8.42-21,9.35-22.68a144.17,144.17,0,0,0,8.42-15.42c1.56-3.45,3.67-7.59,3.24-11.51A7,7,0,0,0,227.35,206.18Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.3,287.89a34,34,0,0,1-2.34,2.58,7,7,0,0,0-1.63,3.74s.47,1.4,1.17.7,2.33-2.81,2.33-2.81a4.32,4.32,0,0,0,2.34-1.87c1.17-1.63,1.64-5.37,1.64-5.37",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,198.18l.12.09C236.23,198.33,236.2,198.3,236,198.18Z",
    style: {
      fill: "#4819F2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.89,245.44s9-2.69,12.45-5.86",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 216.37,
    y1: 248.13,
    x2: 221.01,
    y2: 246.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.01,
    y: 171.71,
    width: 48.19,
    height: 24.32,
    rx: 4.05,
    style: {
      fill: "#4819F2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "269.01 189.67 269.01 202.73 276.29 194.35",
    style: {
      fill: "#4819F2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.81,184.32a2.5,2.5,0,1,0-2.5,2.49A2.5,2.5,0,0,0,285.81,184.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.51,184.32a2.5,2.5,0,1,0-2.5,2.49A2.5,2.5,0,0,0,296.51,184.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.21,184.32a2.5,2.5,0,1,0-2.5,2.49A2.5,2.5,0,0,0,307.21,184.32Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-1--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.24,292.61l-.27-.34A.91.91,0,0,0,102.24,292.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.41,395.63s-12.42,1.6-12.18,2.8,13.47,5.05,14.43,5.05,2.11-6.64,2.11-6.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-9--inject-1--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.46,402.26l-13.73-4.69c-1,.29-1.55.59-1.5.86.24,1.2,13.47,5.05,14.43,5.05C95.93,403.48,96.2,403,96.46,402.26Z",
    style: {
      fill: "#4819F2",
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M93.41,395.63s-12.42,1.6-12.18,2.8,13.47,5.05,14.43,5.05,2.11-6.64,2.11-6.64Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.56,393a12.81,12.81,0,0,1-2.15,2.56c-1,.72-4.57,2.16-4.57,3.13s7.21,1.44,8.66,1.2,3.12-3.13,4.57-4.09-2.59-5-2.59-5A40.43,40.43,0,0,1,142.56,393Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-10--inject-1--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.07,395.78c.49-.33.33-1-.08-1.81a32.29,32.29,0,0,1-5.08,4c-1.74.8-7.34-.13-7.34-.13h-.11c-.38.29-.62.58-.62.83,0,1,7.21,1.44,8.66,1.2S147.62,396.74,149.07,395.78Z",
    style: {
      fill: "#4819F2",
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M142.56,393a12.81,12.81,0,0,1-2.15,2.56c-1,.72-4.57,2.16-4.57,3.13s7.21,1.44,8.66,1.2,3.12-3.13,4.57-4.09-2.59-5-2.59-5A40.43,40.43,0,0,1,142.56,393Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.59,305.57S119.71,344,120.92,347s21.64,46,21.64,46l3.92-2.2-14.65-53,2.78-59.28Z",
    style: {
      fill: "#4819F2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.59,305.57S119.71,344,120.92,347s21.64,46,21.64,46l3.92-2.2-14.65-53,2.78-59.28Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.37,270.22s-5.81,31.26-7,40.47-9.93,84.94-9.93,84.94l4.36,1.21,23-84.7s8-17.93,11.15-23.26S138,275.55,137,271.67,110.37,270.22,110.37,270.22Z",
    style: {
      fill: "#4819F2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.37,270.22s-5.81,31.26-7,40.47-9.93,84.94-9.93,84.94l4.36,1.21,23-84.7s8-17.93,11.15-23.26S138,275.55,137,271.67,110.37,270.22,110.37,270.22Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.39,276.72a128,128,0,0,0-7.76,22.39C112,310.64,108,326,108,329.27s.22,7.76-.89,9.54-3.11,2.22-3.33,6.43,1.55,10.2-1.11,17.07-4.21,10.2-4.21,14.86S96,395.36,96,395.36",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,313.08v17.08c0,11.09,5.1,8,4.65,9.31s-3.1,4.44-2.21,5.55,2.21.44,2.21,2S137.69,375,137.69,375",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.8,
    y1: 377.39,
    x2: 140.57,
    y2: 382.27,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.38,210a10.59,10.59,0,0,0-.25,3.23c.25,1,4.47,2.48,4.47,2.48Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,209.88s3.88,6.3,3.88,7,17.69,16.23,17.69,16.23,4.12,2.43,4.84,3.88.49,10.42-.48,10.66S84.44,220.3,83.23,219.82s-5.33-1.94-5.33-1.94L74,213Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.43,237a11,11,0,0,0-3.2-2.83,17.83,17.83,0,0,1-1.89,4.53,11.06,11.06,0,0,1-1.79,2.16c3.44,4,6.08,6.88,6.4,6.8C108.92,247.44,109.16,238.48,108.43,237Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-11--inject-1--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.43,237a11,11,0,0,0-3.2-2.83,17.83,17.83,0,0,1-1.89,4.53,11.06,11.06,0,0,1-1.79,2.16c3.44,4,6.08,6.88,6.4,6.8C108.92,247.44,109.16,238.48,108.43,237Z",
    style: {
      fill: "#4819F2",
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M108.43,237a11,11,0,0,0-3.2-2.83,17.83,17.83,0,0,1-1.89,4.53,11.06,11.06,0,0,1-1.79,2.16c3.44,4,6.08,6.88,6.4,6.8C108.92,247.44,109.16,238.48,108.43,237Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.48,203.93l-2,.86a1.88,1.88,0,0,0-.73,2.89l8.73,11.14a1.77,1.77,0,0,0,2.57.23l1.48-1.3a1.79,1.79,0,0,0,.25-2.4l-8.07-10.82A1.87,1.87,0,0,0,70.48,203.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.84,207.94S76,212.06,76.2,213s1.46,1.7,2.18,1,3.4-2.91,3.64-4.12A1.64,1.64,0,0,0,79.84,207.94Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.4,264.89l.25,6.3s3.87,3.15,12.84,3.63a32.75,32.75,0,0,0,16.23-3.63L137,261.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-12--inject-1--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.4,264.89l.15,3.87c2.29.84,4.36,1.39,4.36,1.39l-.21,3.05a28.8,28.8,0,0,0,4.39,1.13l2.27-2.48c6.88.9,15.86-2.42,17.92-3.22L137,261.5l-.48.06Z",
    style: {
      fill: "#4819F2",
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M109.4,264.89l.25,6.3s3.87,3.15,12.84,3.63a32.75,32.75,0,0,0,16.23-3.63L137,261.5Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.19,204.06s-2.66,15-4.36,19.39a11.79,11.79,0,0,0,1.45,10.66c1.46,2.18,2.18,18.9,2.18,21.81s-1.93,6.79.73,9.94,16,3.88,23.51,2.91,9.69-5.58,9.69-7.76-7-30.29-10.66-42.41-8.73-20.84-10.91-22.29-.48-2.18-2.66-1.45S110.13,200.67,108.19,204.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-13--inject-1--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.1,266.4c-1.49.27-2.42-.31-3.8-.21,2.2,1.39,6.48,2.5,10.89,3.18,2-3,6.32-10,6.84-14.19.68-5.43,3.06-17,1.36-21.07s-6.79-26.5-8.15-26.5-3.06-5.44-6.12,2.37c0,0-2,3.4-.68,11.22s3.74,11.21,2.38,17,0,10.2,2.38,10.54,3.06,1,2.38,5.09S115.84,265.72,112.1,266.4Z",
    style: {
      fill: "#4819F2",
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.41,231.41a6.81,6.81,0,0,1-2.21-2.93,13,13,0,0,0,2.08,5.63c1.46,2.18,2.18,18.9,2.18,21.81a2.44,2.44,0,0,1,0,.27,40.63,40.63,0,0,0,.5-8.51c-.52-4.11,4.94-9.48,4.94-11.85S108.81,233.79,105.41,231.41Z",
    style: {
      fill: "#4819F2",
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M108.19,204.06s-2.66,15-4.36,19.39a11.79,11.79,0,0,0,1.45,10.66c1.46,2.18,2.18,18.9,2.18,21.81s-1.93,6.79.73,9.94,16,3.88,23.51,2.91,9.69-5.58,9.69-7.76-7-30.29-10.66-42.41-8.73-20.84-10.91-22.29-.48-2.18-2.66-1.45S110.13,200.67,108.19,204.06Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.75,209.52s1.78.89,4.22-2.21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.82,241.63,125.4,245.5s-2.43,8.73-3.88,12.85-9,22.29-9,22.29-4.36,4.85-5.33,6.3-1.21,6.3-.48,7,2.42-1.7,2.42-1.7.49,1.21,2.42.24S116,282.34,116,282.34s10.17-17.45,13.81-23,6.54-10.91,6.54-13.09A27.67,27.67,0,0,0,135.82,241.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-14--inject-1--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.13,243.66c-.07-.55-.14-1-.2-1.38l-2.19.12-8.34,3.1s-2.43,8.73-3.88,12.85-9,22.29-9,22.29-4.36,4.85-5.33,6.3-1.21,6.3-.48,7,2.42-1.7,2.42-1.7a8,8,0,0,1-1.43-3.47c0-1.45,5.5-6.66,5.5-6.66L130.32,248Z",
    style: {
      fill: "#4819F2",
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M135.82,241.63,125.4,245.5s-2.43,8.73-3.88,12.85-9,22.29-9,22.29-4.36,4.85-5.33,6.3-1.21,6.3-.48,7,2.42-1.7,2.42-1.7.49,1.21,2.42.24S116,282.34,116,282.34s10.17-17.45,13.81-23,6.54-10.91,6.54-13.09A27.67,27.67,0,0,0,135.82,241.63Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.4,245.5s-.71,2.55-1.59,5.53a25.52,25.52,0,0,0,5.71,1.26,27.19,27.19,0,0,0,4.41.08c1.45-2.69,2.37-4.91,2.37-6.14a27.67,27.67,0,0,0-.48-4.6Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.13,204.31a10.61,10.61,0,0,0-3.64,6.78c-.48,4.36,3.39,15,3.39,19.87s1,10.91,1.94,13.33,5.33,3.88,9.94,2.67,8.48-1.94,8.48-7.27-4.85-14.54-8.24-22.54S123.7,202.13,118.13,204.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-15--inject-1--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.13,204.31s-1.93,1.51-1,6.74,2.17,12.26,2.53,15.69,6.85-7.21,6.13-3.61S122,237.38,122,239.73s3.07,5.41,6,6,8.37-1,8.37-1a19.73,19.73,0,0,1-4.4,1.83,32.13,32.13,0,0,1-5.7,1L125,247.3s-4.51,0-6-4.15-.36-12.08-2.17-18-2.52-9.56-2.7-12.27S116.26,205.32,118.13,204.31Z",
    style: {
      fill: "#4819F2",
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M118.13,204.31a10.61,10.61,0,0,0-3.64,6.78c-.48,4.36,3.39,15,3.39,19.87s1,10.91,1.94,13.33,5.33,3.88,9.94,2.67,8.48-1.94,8.48-7.27-4.85-14.54-8.24-22.54S123.7,202.13,118.13,204.31Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.93,214.85a40.82,40.82,0,0,1-4.43,13.52",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.61,
    y1: 229.26,
    x2: 120.62,
    y2: 231.7,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.76,195.48a12.35,12.35,0,0,1,5.17,5.17c1.48,3.33,1.85,5.92,3,5.18s8.13-9.47,6.81-10.14c-3-1.47-6.06-8.64-4.59-13.88C112.71,179.64,101.39,191.05,101.76,195.48Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.05,165.75c-3.42,1.72-7.15,4.58-7.15,8.74,0,7.27,2.95,10.14,2.95,11.95s-2.43,4.25-1.52,5.16,3,.6,3,.6a67,67,0,0,0,4.85,7.58c1.82,2.12,5.16-.91,8.8-3.64s5.45-5.15,5.45-10.3,2.55-9,.31-14A12.41,12.41,0,0,0,96.05,165.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-16--inject-1--inject-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.54,164.77c-3.42,1.72-7.15,4.59-7.15,8.74,1.73-.61,4.13-1.22,5.27-.46,1.9,1.26-.31,8.53,6,11.37s7.58,2.53,8.53,4.74c.6,1.4-.4,4.21-2.28,6.44l.57-.43c3.64-2.73,5.46-5.15,5.46-10.31s2.55-8.94.31-14A12.41,12.41,0,0,0,96.54,164.77Z",
    style: {
      fill: "#4819F2",
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M96.05,165.75c-3.42,1.72-7.15,4.58-7.15,8.74,0,7.27,2.95,10.14,2.95,11.95s-2.43,4.25-1.52,5.16,3,.6,3,.6a67,67,0,0,0,4.85,7.58c1.82,2.12,5.16-.91,8.8-3.64s5.45-5.15,5.45-10.3,2.55-9,.31-14A12.41,12.41,0,0,0,96.05,165.75Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.91,187.5l-.77,1.72s1.72,1.72,1.72.38S94.43,186.35,92.91,187.5Z",
    style: {
      fill: "#4819F2",
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.55,193.34a4.23,4.23,0,0,0,2.66-3.33",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.45,183.58l.44,2A2.77,2.77,0,0,0,98,184.47",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.67,181.81a3.38,3.38,0,0,1,4-1.56",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8269559999999999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.87,197.77c-.85.64-1.65,1.23-2.42,1.7,2.51,7.2-5.65,15.41-2.2,23.18a25.25,25.25,0,0,0,2.87,4.75q0-.43,0-.87a2.11,2.11,0,0,1,0-.26c0-.22,0-.43.08-.65s0-.2,0-.31.09-.43.15-.64,0-.19.07-.29c.09-.31.19-.62.31-.93,1.7-4.36,4.36-19.39,4.36-19.39a.56.56,0,0,0,0-.08c-.34-.9-.74-2.06-1.31-3.33A9.46,9.46,0,0,0,104.87,197.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.29,242.51c-8.24-7-6.78-10.18-4.6-15.51s1.7-16.72-7-24.48-19.87-3.39-25-13.32-.24-11.64-3.15-20.12S112,154.54,104,155a17.7,17.7,0,0,0-5.79,1.4c-13,.32-17.4,7-14.68,13.4a5.32,5.32,0,0,0,6.71,2.76c2.2-.8,5.15-1.29,6.56,1,2.43,3.88,1.48,9.9,8.75,11.35,3.59.72,5.75,1.56,6.83,2.77,0,.29-.06.59-.11.86a17.09,17.09,0,0,0,.84,2.44,11,11,0,0,1-.54,1.93c-1.69,4.6-5.33,9,.25,11.87s4.06-.76,7.93-.76,5.92,5,5.92,5a68.57,68.57,0,0,1,4.08,9.55l.21.7c3.28,7.45,7.3,15.53,7.3,20.39a6.52,6.52,0,0,1-.89,3.56c.84,3.34,1.62,6.52,2.26,9.24v0c.1.43.2.85.29,1.26l0,.06c.09.42.19.83.28,1.22v0c.08.34.15.66.22,1l0,.19c.06.27.11.52.16.76s.05.2.07.29c0,.24.1.46.14.68l.06.26c0,.2.08.38.11.56l.06.26c0,.16.06.31.08.45a2.21,2.21,0,0,1,.05.25c0,.13,0,.24.06.35s0,.15,0,.21,0,.18,0,.26a.88.88,0,0,0,0,.17c0,.12,0,.21,0,.28a3.28,3.28,0,0,1,0,.52l0,.15a3.82,3.82,0,0,1-.09.44c0,.06,0,.11,0,.17s-.12.37-.2.56l0,.07a7.33,7.33,0,0,1-.79,1.43l0,.07a6.82,6.82,0,0,1-.55.68l0,0a9.11,9.11,0,0,1-1.62,1.41l.81,4.63s-.6.34-1.66.81a20.39,20.39,0,0,0,5.94,1.77c12.6,1.94,18.66-1.46,23.26-8S173.53,249.54,165.29,242.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.74,170.11s3.48,2.66,9.21.41,10.65-2.66,14.33,1.84,5.94,6.55,8.4,6.55,8.8,5.12,9.41,11.26,3.89,8.19,8.4,9.83",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.35,200.62a38.26,38.26,0,0,0,5.94,1c2.87.2,4.92.2,7,2.46",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.07,173a17.39,17.39,0,0,1,4.5,6.55c1.23,3.68,7.58,4.71,10.85,4.5",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.09,168.27s-2.67-4.92-7.37-7-8.6.81-15,3.48-10.24.82-10.24.82",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,207.78s3.68,5.94,8.6,9.42,10.44,6.14,7.78,14.74-4.92,13.31,1.43,18.84,8.6,14.33,6.14,17.81",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.29,186.46s4.06,3.56,2.88,7.11-6.77,5.59-3.56,8.47,9.82.34,11.35.85a6.35,6.35,0,0,1,2.54,1.69",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.08,184.63s4.64,2,4.92,6.11-2.94,6.31-2.19,8,3.23-.24,6,.75",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.77,
    y: 176.7,
    width: 48.19,
    height: 24.32,
    rx: 4.05,
    transform: "translate(109.72 377.73) rotate(180)",
    style: {
      fill: "#4819F2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "78.95 194.66 78.95 207.73 71.67 199.34",
    style: {
      fill: "#4819F2"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.65,
    cy: 189.31,
    r: 2.5,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.45,189.31a2.5,2.5,0,1,1,2.5,2.5A2.5,2.5,0,0,1,51.45,189.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.25,
    cy: 189.31,
    r: 2.5,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.19,
    y1: 245.86,
    x2: 159.06,
    y2: 249.14,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.1,250.57a13.21,13.21,0,0,1,2.26,12.9",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.620217px"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBro);
export default __webpack_public_path__ + "static/media/chat_bro.ab0ba8c76602757e6b6774e3bb8c3edc.svg";
export { ForwardRef as ReactComponent };